/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconArrowRight from '@telus-uds/palette-koodo/build/rn/icons/ArrowRight'
import PaletteIconExclamationTriangle from '@telus-uds/palette-koodo/build/rn/icons/ExclamationTriangle'
import PaletteIconExclamationOctagon from '@telus-uds/palette-koodo/build/rn/icons/ExclamationOctagon'
import PaletteIconChevronRight from '@telus-uds/palette-koodo/build/rn/icons/ChevronRight'
import PaletteIconChevronDown from '@telus-uds/palette-koodo/build/rn/icons/ChevronDown'
import PaletteIconChevronUp from '@telus-uds/palette-koodo/build/rn/icons/ChevronUp'
import PaletteIconCheck from '@telus-uds/palette-koodo/build/rn/icons/Check'
import PaletteIconPause from '@telus-uds/palette-koodo/build/rn/icons/Pause'
import PaletteIconPlay from '@telus-uds/palette-koodo/build/rn/icons/Play'
import PaletteIconChevronLeft from '@telus-uds/palette-koodo/build/rn/icons/ChevronLeft'
import PaletteIconAndroidEN from '@telus-uds/palette-koodo/build/rn/icons/AndroidEN'
import PaletteIconAndroidFR from '@telus-uds/palette-koodo/build/rn/icons/AndroidFR'
import PaletteIconIOSEN from '@telus-uds/palette-koodo/build/rn/icons/IOSEN'
import PaletteIconIOSFR from '@telus-uds/palette-koodo/build/rn/icons/IOSFR'
import PaletteIconCheckCircleFilled from '@telus-uds/palette-koodo/build/rn/icons/CheckCircleFilled'
import PaletteIconClose from '@telus-uds/palette-koodo/build/rn/icons/Close'
import PaletteIconAdd from '@telus-uds/palette-koodo/build/rn/icons/Add'
import PaletteIconSubtract from '@telus-uds/palette-koodo/build/rn/icons/Subtract'
import PaletteIconExpand from '@telus-uds/palette-koodo/build/rn/icons/Expand'
import PaletteIconPlayVideo from '@telus-uds/palette-koodo/build/rn/icons/PlayVideo'
import PaletteIconBullet from '@telus-uds/palette-koodo/build/rn/icons/Bullet'
import PaletteIconTimes from '@telus-uds/palette-koodo/build/rn/icons/Times'
import PaletteIconTagFilled from '@telus-uds/palette-koodo/build/rn/icons/TagFilled'
import PaletteIconSpyglass from '@telus-uds/palette-koodo/build/rn/icons/Spyglass'
import PaletteIconPlaySolid from '@telus-uds/palette-koodo/build/rn/icons/PlaySolid'
import PaletteIconToolTipFilled from '@telus-uds/palette-koodo/build/rn/icons/ToolTipFilled'
import PaletteIconTooltip from '@telus-uds/palette-koodo/build/rn/icons/Tooltip'
import PaletteIconCheckCircledFilled from '@telus-uds/palette-koodo/build/rn/icons/CheckCircledFilled'
import PaletteIconQuoteLeft from '@telus-uds/palette-koodo/build/rn/icons/QuoteLeft'
import PaletteIconQuoteRightArrow from '@telus-uds/palette-koodo/build/rn/icons/QuoteRightArrow'
import PaletteIconAmex from '@telus-uds/palette-koodo/build/rn/icons/Amex'
import PaletteIconCreditCard from '@telus-uds/palette-koodo/build/rn/icons/CreditCard'
import PaletteIconMasterCard from '@telus-uds/palette-koodo/build/rn/icons/MasterCard'
import PaletteIconEyeMasked from '@telus-uds/palette-koodo/build/rn/icons/EyeMasked'
import PaletteIconEyeUnmasked from '@telus-uds/palette-koodo/build/rn/icons/EyeUnmasked'
import PaletteIconVisa from '@telus-uds/palette-koodo/build/rn/icons/Visa'
import PaletteIconTooltipSymbol from '@telus-uds/palette-koodo/build/rn/icons/TooltipSymbol'
import PaletteIconReplay from '@telus-uds/palette-koodo/build/rn/icons/Replay'
import PaletteIconClosedCaptions from '@telus-uds/palette-koodo/build/rn/icons/ClosedCaptions'
import PaletteIconFullscreenExpand from '@telus-uds/palette-koodo/build/rn/icons/FullscreenExpand'
import PaletteIconFullscreenMinimize from '@telus-uds/palette-koodo/build/rn/icons/FullscreenMinimize'
import PaletteIconSettingsSolid from '@telus-uds/palette-koodo/build/rn/icons/SettingsSolid'
import PaletteIconArrowLeft from '@telus-uds/palette-koodo/build/rn/icons/ArrowLeft'
import PaletteIconMuted from '@telus-uds/palette-koodo/build/rn/icons/Muted'
import PaletteIconUnmuted from '@telus-uds/palette-koodo/build/rn/icons/Unmuted'
const theme = {
  components: {
    ActionCard: {
      appearances: {
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success', 'warning', 'feature' ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { actionIconTranslate: 4 } },
        {
          if: { validation: 'warning' },
          tokens: {
            actionIconMarginLeft: 8,
            backgroundColor: '#fff5d2',
            borderColor: '#f8c100',
            statusIcon: PaletteIconExclamationTriangle,
            statusIconColor: '#c9370b'
          }
        },
        {
          if: { validation: 'error' },
          tokens: {
            actionIconMarginLeft: 8,
            backgroundColor: '#fcd3c6',
            borderColor: '#c9370b',
            statusIcon: PaletteIconExclamationOctagon,
            statusIconColor: '#c9370b'
          }
        }
      ],
      tokens: {
        actionIcon: PaletteIconArrowRight,
        actionIconColor: '#000000',
        actionIconMarginBottom: 8,
        actionIconMarginLeft: 0,
        actionIconMarginRight: 0,
        actionIconMarginTop: 8,
        actionIconTranslate: 4,
        backgroundColor: null,
        borderColor: null,
        borderRadius: null,
        borderWidth: null,
        contentFontColor: '#000000',
        contentFontName: 'StagSans',
        contentFontSize: 16,
        contentFontWeight: '400',
        contentLineHeight: 1.25,
        contentMarginBottom: 8,
        contentMarginLeft: 0,
        contentMarginRight: 0,
        contentMarginTop: 0,
        iconBackgroundColor: 'rgba(0, 0, 0, 0.05)',
        iconColor: '#000000',
        iconMarginBottom: 0,
        iconMarginLeft: 0,
        iconMarginRight: 8,
        iconMarginTop: 0,
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 16,
        statusIcon: null,
        statusIconColor: null,
        titleFontColor: '#000000',
        titleFontName: 'StagSans',
        titleFontSize: 16,
        titleFontWeight: '700',
        titleLineHeight: 1.5,
        titleMarginBottom: 8,
        titleMarginLeft: 0,
        titleMarginRight: 8,
        titleMarginTop: 8
      }
    },
    ActivityIndicator: {
      appearances: {
        dots: { type: 'variant', values: [ true ] },
        size: {
          description: 'used for full-screen spinners',
          type: 'variant',
          values: [ 'large', 'small' ]
        },
        style: { type: 'variant', values: [ 'dots' ] }
      },
      rules: [
        {
          if: { size: 'large' },
          tokens: { dotSize: 12, size: 48, thickness: 4 }
        },
        {
          if: { size: 'small' },
          tokens: { dotSize: 6, size: 24, thickness: 3 }
        }
      ],
      tokens: {
        color: '#ff0076',
        dotSize: 12,
        fullScreenOverlayBackground: 'rgba(255, 255, 255, 0.8)',
        indicatorBackgroundColor: '#ffd1e6',
        size: 48,
        thickness: 4
      }
    },
    Autocomplete: {
      appearances: {},
      rules: [],
      tokens: { color: '#666666', maxHeight: '100%', overflowY: 'visible' }
    },
    Badge: {
      appearances: {
        alternative: { type: 'variant', values: [ true ] },
        inverse: { type: 'variant', values: [ true ] },
        outline: { type: 'variant', values: [ true ] },
        purpose: { type: 'variant', values: [ 'offer', 'editorial', 'subtle' ] },
        size: { type: 'variant', values: [ 'compact' ] }
      },
      rules: [
        {
          if: { inverse: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#ffffff',
            color: '#ffffff'
          }
        },
        {
          if: { outline: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#a1ed00'
          }
        },
        {
          if: { alternative: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#dd0066',
            color: '#dd0066',
            fontSize: 16,
            paddingBottom: 8,
            paddingTop: 8
          }
        },
        {
          if: { purpose: 'offer' },
          tokens: {
            backgroundColor: '#7a3dfc',
            color: '#ffffff',
            fontSize: 16,
            paddingBottom: 8,
            paddingTop: 8
          }
        },
        {
          if: { purpose: 'editorial' },
          tokens: {
            backgroundColor: '#ffad00',
            color: '#000000',
            fontSize: 16
          }
        },
        {
          if: { purpose: 'subtle' },
          tokens: {
            backgroundColor: '#e0d8fc',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#000000'
          }
        },
        {
          if: { outline: true, purpose: 'subtle' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#e0d8fc'
          }
        },
        {
          if: { outline: true, purpose: 'editorial' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#ffad00',
            color: '#000000'
          }
        },
        {
          if: { outline: true, purpose: 'offer' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#7a3dfc',
            color: '#000000'
          }
        },
        {
          if: { size: 'compact' },
          tokens: {
            fontSize: 14,
            paddingBottom: 0,
            paddingLeft: 3,
            paddingRight: 3,
            paddingTop: 0
          }
        }
      ],
      tokens: {
        backgroundColor: '#a1ed00',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 32,
        borderWidth: 2,
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 14,
        fontWeight: '600',
        gradient: null,
        paddingBottom: 2,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 2
      }
    },
    BlockQuote: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm', 'md' ] },
          tokens: {
            titleHeadingFontName: 'StagSans',
            titleHeadingFontSize: 32,
            titleHeadingFontWeight: '700',
            titleHeadingLineHeight: 1.25
          }
        }
      ],
      tokens: {
        backgroundGradient: {
          angle: 0,
          stops: [
            { color: '#000000', stop: 0 },
            { color: '#000000', stop: 1 }
          ],
          type: 'linear'
        },
        color: '#000000',
        linkFontName: 'StagSans',
        linkFontSize: 16,
        linkFontWeight: '600',
        linkLineHeight: 1.5,
        marginBottom: 16,
        paddingBottom: 16,
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 16,
        titleFontName: 'StagSans',
        titleFontSize: 20,
        titleFontWeight: '400',
        titleHeadingFontName: 'StagSans',
        titleHeadingFontSize: 32,
        titleHeadingFontWeight: '700',
        titleHeadingLineHeight: 1.25,
        titleLineHeight: 1.4,
        width: 4
      }
    },
    Box: {
      appearances: {
        background: {
          description: 'Background colour of box. White if not specified.',
          type: 'variant',
          values: [
            'lightest',         'lighter',
            'light',            'dark',
            'darker',           'darkest',
            'critical',         'danger',
            'warning',          'positive',
            'brand',            'white',
            'black',            'featurePrimary',
            'featureSecondary', 'featureNeutral',
            'featureBrand'
          ]
        }
      },
      rules: [
        {
          if: { background: 'lightest' },
          tokens: { backgroundColor: '#ffffff', borderColor: '#ffffff' }
        },
        {
          if: { background: 'lighter' },
          tokens: { backgroundColor: '#fafafa', borderColor: '#fafafa' }
        },
        {
          if: { background: 'light' },
          tokens: { backgroundColor: '#efefef', borderColor: '#efefef' }
        },
        {
          if: { background: 'dark' },
          tokens: { backgroundColor: '#666666', borderColor: '#666666' }
        },
        {
          if: { background: 'darker' },
          tokens: { backgroundColor: '#595959', borderColor: '#595959' }
        },
        {
          if: { background: 'darkest' },
          tokens: { backgroundColor: '#000000', borderColor: '#000000' }
        },
        {
          if: { background: 'critical' },
          tokens: { backgroundColor: '#c9370b', borderColor: '#c9370b' }
        },
        {
          if: { background: 'danger' },
          tokens: { backgroundColor: '#fcd3c6', borderColor: '#fcd3c6' }
        },
        {
          if: { background: 'warning' },
          tokens: { backgroundColor: '#fff5d2', borderColor: '#fff5d2' }
        },
        {
          if: { background: 'positive' },
          tokens: { backgroundColor: '#c5f2cc', borderColor: '#c5f2cc' }
        },
        {
          if: { background: 'brand' },
          tokens: { backgroundColor: '#7a3dfc', borderColor: '#7a3dfc' }
        },
        {
          if: { background: 'white' },
          tokens: { backgroundColor: '#ffffff', borderColor: '#ffffff' }
        },
        {
          if: { background: 'black' },
          tokens: { backgroundColor: '#000000', borderColor: '#000000' }
        },
        {
          if: { background: 'featurePrimary' },
          tokens: { backgroundColor: '#a1ed00', borderColor: '#a1ed00' }
        },
        {
          if: { background: 'featureSecondary' },
          tokens: { backgroundColor: '#ff0076', borderColor: '#ff0076' }
        },
        {
          if: { background: 'featureNeutral' },
          tokens: { backgroundColor: '#ffad00', borderColor: '#ffad00' }
        },
        {
          if: { background: 'featureBrand' },
          tokens: { backgroundColor: '#e0d8fc', borderColor: '#e0d8fc' }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderWidth: 0,
        gradient: null
      }
    },
    Breadcrumbs: {
      appearances: { inverse: { type: 'variant', values: [ true ] } },
      rules: [
        {
          if: { inverse: true },
          tokens: {
            color: '#ffffff',
            currentColor: '#ffffff',
            iconColor: '#c9c8c8'
          }
        }
      ],
      tokens: {
        color: '#000000',
        currentColor: '#000000',
        fontName: 'StagSans',
        fontSize: 14,
        fontWeight: '600',
        icon: PaletteIconChevronRight,
        iconColor: '#000000',
        iconContainerSize: 20,
        iconPadding: 4,
        iconSize: 16,
        lineHeight: 1.42857142857,
        listItemPadding: 0
      }
    },
    Button: {
      appearances: {
        danger: {
          description: 'Indicates a user action that is destructive and will result in loss of information or cause significant monetary charges. Limit the use of the danger button whenever possible.',
          type: 'variant',
          values: [ true ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        inverse: {
          description: 'Use inverse buttons on darker backgrounds. High and low priority buttons, and danger buttons, are available in inverse.',
          type: 'variant',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        priority: {
          description: 'Indicates the importance of the call-to-action. Limit the amount of high priority buttons on a page to prioritize meaningful user flows. Low priority styles are applied by default.',
          type: 'variant',
          values: [ 'high', 'low' ]
        },
        size: { type: 'variant', values: [ 'small' ] },
        text: {
          description: 'Text variant visually deprioritize the button styles',
          type: 'variant',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        },
        width: {
          description: 'Available in default, full-width or responsive. Default-width expands based on content. Full-width expands to width of the container. Responsive automatically applies full-width when is displayed on the XS viewport.',
          type: 'variant',
          values: [ 'full', 'responsive' ]
        }
      },
      rules: [
        {
          if: { danger: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderBottomWidth: 1,
            borderColor: '#c9370b',
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderTopWidth: 1,
            color: '#c9370b'
          }
        },
        {
          if: { inverse: true },
          tokens: {
            backgroundColor: '#ffffff',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#000000',
            outerBackgroundColor: 'rgba(0, 0, 0, 0)'
          }
        },
        {
          if: { priority: 'high' },
          tokens: { backgroundColor: '#000000', borderColor: '#000000' }
        },
        {
          if: { priority: 'low' },
          tokens: {
            backgroundColor: '#ffffff',
            borderBottomWidth: 1,
            borderColor: '#000000',
            color: '#000000',
            outerBackgroundColor: 'rgba(0, 0, 0, 0)'
          }
        },
        {
          if: { inverse: true, priority: 'high' },
          tokens: {
            backgroundColor: '#ffffff',
            borderColor: '#000000',
            borderWidth: 1
          }
        },
        {
          if: { inverse: true, priority: 'low' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#ffffff',
            borderWidth: 1,
            color: '#ffffff'
          }
        },
        {
          if: { hover: true },
          tokens: { backgroundColor: '#404040', color: '#ffffff' }
        },
        {
          if: { focus: true },
          tokens: {
            borderBottomWidth: 1,
            borderColor: '#000000',
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderTopWidth: 1,
            color: '#ffffff',
            outerBorderColor: '#000000',
            outerBorderGap: 4,
            outerBorderWidth: 1
          }
        },
        {
          if: { hover: true, priority: 'low' },
          tokens: { borderBottomWidth: 1, outerBorderColor: '#000000' }
        },
        {
          if: { focus: true, priority: 'low' },
          tokens: { color: '#000000' }
        },
        {
          if: { focus: true, hover: true, priority: 'low' },
          tokens: { color: '#ffffff' }
        },
        {
          if: { danger: true, focus: true },
          tokens: {
            borderBottomWidth: 1,
            borderColor: '#c9370b',
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderTopWidth: 1,
            borderWidth: 1,
            color: '#c9370b',
            outerBorderColor: '#c9370b',
            outerBorderGap: 2
          }
        },
        {
          if: { focus: true, inverse: true, priority: 'high' },
          tokens: {
            backgroundColor: '#ffffff',
            borderColor: '#000000',
            borderWidth: 1,
            color: '#000000',
            outerBackgroundColor: 'rgba(0, 0, 0, 0)',
            outerBorderColor: '#000000',
            outerBorderGap: 2,
            outerBorderWidth: 1
          }
        },
        {
          if: { hover: true, inverse: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            borderColor: '#c9c8c8',
            color: '#404040',
            outerBorderColor: '#c9c8c8',
            outerBorderWidth: 1
          }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: { backgroundColor: '#c9c8c8', color: '#666666' }
        },
        {
          if: { focus: true, inverse: true },
          tokens: {
            borderBottomWidth: 1,
            borderColor: 'rgba(0, 0, 0, 0)',
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderTopWidth: 1,
            color: '#000000',
            outerBorderColor: '#ffffff',
            outerBorderGap: 2
          }
        },
        {
          if: { danger: true, inverse: true },
          tokens: {
            backgroundColor: '#ffffff',
            borderBottomWidth: 0,
            borderColor: 'rgba(0, 0, 0, 0)',
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            color: '#c9370b'
          }
        },
        {
          if: { focus: true, inverse: true, pressed: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            borderColor: '#c9c8c8',
            color: '#666666',
            outerBorderGap: 2
          }
        },
        {
          if: { focus: true, inverse: true, priority: 'low' },
          tokens: {
            borderColor: '#ffffff',
            borderWidth: 1,
            color: '#ffffff',
            outerBackgroundColor: 'rgba(0, 0, 0, 0)',
            outerBorderColor: '#ffffff',
            outerBorderGap: 2,
            outerBorderWidth: 1
          }
        },
        { if: { width: 'full' }, tokens: { width: '100%' } },
        {
          if: { viewport: [ 'xs' ], width: 'responsive' },
          tokens: { width: '100%' }
        },
        {
          if: { size: 'small' },
          tokens: {
            minWidth: 0,
            paddingBottom: 4,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 4
          }
        },
        {
          if: { text: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 0,
            color: '#000000',
            minWidth: 0,
            paddingLeft: 0,
            paddingRight: 0,
            textLine: 'underline'
          }
        },
        {
          if: { focus: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#000000',
            outerBorderColor: '#000000'
          }
        },
        {
          if: { hover: true, text: true },
          tokens: { color: '#404040', textLine: 'none' }
        },
        {
          if: { danger: true, text: true },
          tokens: { color: '#c9370b' }
        },
        {
          if: { danger: true, focus: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#c9370b',
            outerBorderColor: '#c9370b'
          }
        },
        {
          if: { hover: true, priority: 'low' },
          tokens: { borderColor: 'rgba(0, 0, 0, 0)', borderWidth: 0 }
        },
        {
          if: { pressed: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#595959',
            textLine: 'none'
          }
        },
        {
          if: { danger: true, hover: true },
          tokens: { backgroundColor: '#f3592b', color: '#ffffff' }
        },
        {
          if: { danger: true, hover: true, text: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: '#f3592b',
            outerBorderColor: 'rgba(0, 0, 0, 0)'
          }
        },
        {
          if: { danger: true, pressed: true },
          tokens: {
            backgroundColor: '#404040',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#666666',
            outerBorderGap: 0
          }
        },
        {
          if: { danger: true, pressed: true, text: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#666666',
            textLine: 'none'
          }
        },
        {
          if: { inverse: true, text: true },
          tokens: { backgroundColor: 'rgba(0, 0, 0, 0)', color: '#ffffff' }
        },
        {
          if: { focus: true, inverse: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#ffffff',
            outerBorderColor: '#ffffff'
          }
        },
        {
          if: { hover: true, inverse: true, text: true },
          tokens: { color: '#c9c8c8' }
        },
        {
          if: { inverse: true, pressed: true, text: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#666666',
            outerBorderColor: '#666666'
          }
        },
        {
          if: { inactive: true, inverse: true, text: true },
          tokens: { borderColor: 'rgba(0, 0, 0, 0)', color: '#c9c8c8' }
        },
        {
          if: { pressed: true },
          tokens: {
            borderBottomWidth: 0,
            color: '#666666',
            outerBorderColor: 'rgba(0, 0, 0, 0)'
          }
        },
        {
          description: 'Buttons should not be disabled or set as inactive. Use inline (on blur) error messaging to provide feedback when the form is invalid. In exceptional instances where disabled buttons are needed, it must be clear to the user why the button is disabled and what they need to do to enable it.',
          if: { inactive: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            borderColor: '#c9c8c8',
            borderWidth: 0,
            color: '#ffffff',
            outerBorderColor: 'rgba(0, 0, 0, 0)'
          }
        },
        {
          if: { priority: 'low', text: true },
          tokens: { color: '#7a3dfc' }
        },
        {
          if: { hover: true, priority: 'low', text: true },
          tokens: { color: '#5b2bc2', outerBorderColor: 'rgba(0, 0, 0, 0)' }
        },
        {
          if: { focus: true, priority: 'low', text: true },
          tokens: {
            color: '#7a3dfc',
            outerBorderColor: '#7a3dfc',
            outerBorderWidth: 1
          }
        },
        {
          if: { pressed: true, priority: 'low', text: true },
          tokens: {
            color: '#666666',
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            outerBorderWidth: 0
          }
        },
        {
          if: { inactive: true, text: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#c9c8c8',
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            textLine: 'none'
          }
        }
      ],
      tokens: {
        backgroundColor: '#000000',
        borderBottomWidth: 0,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderLeftWidth: 1,
        borderRadius: 4,
        borderRightWidth: 1,
        borderTopWidth: 1,
        borderWidth: 1,
        color: '#ffffff',
        flex: 0,
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        height: null,
        icon: null,
        iconSize: 16,
        iconSpace: 2,
        lineHeight: 1.5,
        minWidth: 144,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: null,
        outerBorderWidth: 1,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        shadow: null,
        textAlign: 'center',
        textLine: 'none',
        textLineStyle: 'solid',
        width: null
      }
    },
    ButtonDropdown: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        open: {
          description: 'Applies when a ButtonDropdown is open.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        size: { type: 'variant', values: [ 'default', 'small' ] },
        width: { type: 'variant', values: [ 'full' ] }
      },
      rules: [
        {
          if: { open: true },
          tokens: { icon: PaletteIconChevronUp }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#000000' }
        },
        {
          if: { focus: false, hover: true, pressed: false },
          tokens: {
            backgroundColor: '#404040',
            borderColor: 'rgba(0, 0, 0, 0)'
          }
        },
        {
          if: { focus: true, hover: true, pressed: false },
          tokens: {
            backgroundColor: '#404040',
            borderColor: 'rgba(0, 0, 0, 0)'
          }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            borderColor: '#c9c8c8',
            color: '#ffffff',
            iconColor: '#ffffff',
            leadIconColor: '#ffffff'
          }
        },
        {
          if: { hover: true, selected: true },
          tokens: { backgroundColor: '#404040' }
        },
        {
          if: { focus: true, hover: false, selected: true },
          tokens: {
            outerBorderColor: '#000000',
            outerBorderGap: 2,
            outerBorderWidth: 1
          }
        },
        {
          if: { hover: true, pressed: true, selected: true },
          tokens: {
            backgroundColor: '#404040',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#666666',
            iconColor: '#666666',
            leadIconColor: '#666666'
          }
        },
        {
          if: { focus: true, pressed: true, selected: true },
          tokens: { backgroundColor: '#404040', outerBorderColor: '#404040' }
        },
        {
          if: { hover: true },
          tokens: {
            color: '#ffffff',
            iconColor: '#ffffff',
            leadIconColor: '#ffffff'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#404040',
            borderColor: '#404040',
            color: '#666666',
            iconColor: '#666666',
            leadIconColor: '#666666'
          }
        },
        {
          if: { size: 'small' },
          tokens: { paddingBottom: 4, paddingTop: 4 }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#ffffff',
        borderColor: '#000000',
        borderRadius: 4,
        borderWidth: 1,
        color: '#000000',
        descriptionFontName: 'StagSans',
        descriptionFontSize: 14,
        descriptionFontWeight: '400',
        descriptionLineHeight: 1.42857142857,
        descriptionTextPaddingBottom: 0,
        dividerColor: '#c9c8c8',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        icon: PaletteIconChevronDown,
        iconAlignSelf: 'center',
        iconBackground: 'rgba(0, 0, 0, 0)',
        iconBorderRadius: 32,
        iconColor: '#000000',
        iconPadding: 0,
        iconPosition: 'right',
        iconSize: 20,
        iconSpace: 1,
        iconTranslateX: 0,
        iconTranslateY: 0,
        leadIcon: null,
        leadIconBackgroundColor: 'transparent',
        leadIconBorderRadius: 0,
        leadIconColor: '#000000',
        leadIconContainerPaddingBottom: 0,
        leadIconContainerPaddingLeft: 0,
        leadIconContainerPaddingRight: 0,
        leadIconContainerPaddingTop: 0,
        leadIconPadding: 0,
        leadIconSize: 24,
        lineHeight: 1.5,
        minWidth: 0,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderWidth: 1,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        shadow: null,
        subtitleColor: '#000000',
        textAlign: 'center',
        textPaddingLeft: 8,
        textPaddingRight: 8,
        width: null
      }
    },
    ButtonGroup: {
      appearances: {
        style: {
          description: 'Configure `style` variant for `ButtonGroup`',
          type: 'variant',
          values: [ 'contained' ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        },
        width: {
          description: 'Available in default, responsive or equal. Default-width expands based on content. Responsive automatically applies full-width when is displayed on the XS viewport, equal divide the available width equally among `ButtonGroup`',
          type: 'variant',
          values: [ 'responsive', 'equal' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: { gap: 2, space: 2 }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: { gap: 3, space: 3 }
        },
        {
          if: { viewport: [ 'xs' ], width: 'responsive' },
          tokens: { alignItems: 'stretch', direction: 'column' }
        },
        {
          if: { style: 'contained' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderRadius: 8,
            padding: 8,
            space: 2
          }
        }
      ],
      tokens: {
        alignItems: 'center',
        backgroundColor: null,
        borderRadius: 0,
        direction: 'row',
        fieldSpace: 2,
        flexGrow: 0,
        flexShrink: 0,
        gap: 2,
        justifyContent: 'flex-start',
        padding: 0,
        space: 2
      }
    },
    ButtonGroupItem: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        iconPosition: {
          description: 'Theme styles to be applied to icon links depending on where the icon is in relation to the link text',
          type: 'state',
          values: [ 'left', 'right', 'inline' ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        size: { type: 'variant', values: [ 'small' ] },
        style: {
          description: 'Configure `style` variant for `ButtonGroupItem`',
          type: 'variant',
          values: [ 'contained' ]
        },
        width: {
          description: 'Available in default, responsive or equal. Default-width expands based on content. Responsive automatically applies full-width when is displayed on the XS viewport, equal divide the available width equally among `ButtonGroup`',
          type: 'variant',
          values: [ 'responsive', 'equal' ]
        }
      },
      rules: [
        { if: { width: 'equal' }, tokens: { width: '100%' } },
        {
          if: { size: 'small' },
          tokens: { height: 32, paddingBottom: 4, paddingTop: 4 }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#000000' }
        },
        {
          if: { hover: true },
          tokens: {
            backgroundColor: '#404040',
            borderColor: '#404040',
            color: '#ffffff'
          }
        },
        {
          if: { selected: true },
          tokens: { backgroundColor: '#7a3dfc', color: '#ffffff' }
        },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#404040', color: '#666666' }
        },
        {
          if: { focus: true, selected: true },
          tokens: {
            backgroundColor: '#7a3dfc',
            color: '#ffffff',
            outerBorderColor: '#7a3dfc'
          }
        },
        {
          if: { hover: true, selected: true },
          tokens: { backgroundColor: '#5b2bc2', color: '#ffffff' }
        },
        {
          if: { pressed: true, selected: true },
          tokens: { backgroundColor: '#404040', color: '#666666' }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            borderWidth: 0,
            color: '#ffffff'
          }
        },
        { if: { iconPosition: 'right' }, tokens: { iconSpace: 1 } },
        { if: { width: 'responsive' }, tokens: { width: '100%' } },
        {
          if: { style: 'contained' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 0,
            height: 40,
            paddingBottom: 8,
            paddingTop: 8
          }
        },
        {
          if: { size: 'small', style: 'contained' },
          tokens: { height: 32, paddingBottom: 6, paddingTop: 6 }
        },
        {
          if: { hover: true, style: 'contained' },
          tokens: {
            backgroundColor: '#404040',
            color: '#ffffff',
            outerBorderWidth: 0
          }
        },
        {
          if: { selected: true, style: 'contained' },
          tokens: {
            backgroundColor: '#7a3dfc',
            color: '#ffffff',
            outerBorderWidth: 0
          }
        },
        {
          if: { focus: true, style: 'contained' },
          tokens: {
            borderColor: '#000000',
            borderWidth: 1,
            outerBorderWidth: 0
          }
        },
        {
          if: { hover: true, selected: true, style: 'contained' },
          tokens: {
            backgroundColor: '#5b2bc2',
            color: '#ffffff',
            outerBorderWidth: 0
          }
        },
        {
          if: { focus: true, selected: true, style: 'contained' },
          tokens: { outerBorderColor: '#7a3dfc', outerBorderWidth: 1 }
        },
        {
          if: { pressed: true, style: 'contained' },
          tokens: { backgroundColor: '#404040', color: '#666666' }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#ffffff',
        borderColor: '#000000',
        borderRadius: 4,
        borderWidth: 1,
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        height: 48,
        iconSize: 20,
        iconSpace: 2,
        lineHeight: 1.5,
        minWidth: 0,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 3,
        outerBorderWidth: 1,
        paddingBottom: 12,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 12,
        shadow: null,
        textAlign: 'center',
        width: null
      }
    },
    Callout: {
      appearances: {
        rounded: { type: 'variant', values: [ true ] },
        size: { type: 'variant', values: [ 'small' ] }
      },
      rules: [
        {
          if: { size: 'small' },
          tokens: { paddingBottom: 4, paddingTop: 4 }
        },
        { if: { rounded: true }, tokens: { borderRadius: 4 } }
      ],
      tokens: {
        background: '#7a3dfc',
        borderRadius: 0,
        color: '#ffffff',
        gap: 16,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8
      }
    },
    Card: {
      appearances: {
        background: {
          description: 'Defines background related attributes of Card',
          type: 'variant',
          values: [ 'alternative', 'subtle', 'grid', 'feature', 'plain' ]
        },
        borderRadius: { type: 'variant', values: [ 'none', 'small', 'large' ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        interactive: { type: 'variant', values: [ true ] },
        isControl: { type: 'variant', values: [ true, false ] },
        padding: {
          type: 'variant',
          values: [ 'narrow', 'intermediate', 'compact', 'custom' ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        style: {
          type: 'variant',
          values: [
            'grid',     'light',
            'lighter',  'lightest',
            'dark',     'darker',
            'darkest',  'feature',
            'feature2', 'feature3',
            'feature4', 'warning',
            'error',    'success'
          ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { interactive: true },
          tokens: { backgroundColor: 'transparent' }
        },
        {
          if: { interactive: true, isControl: true },
          tokens: { borderColor: '#c9c8c8', borderWidth: 1 }
        },
        {
          if: { interactive: true, isControl: true, selected: true },
          tokens: {
            backgroundColor: '#efefef',
            borderColor: '#000000',
            borderWidth: 1,
            iconBackgroundColor: '#c9c8c8',
            iconColor: '#000000',
            inputBackgroundColor: '#c9c8c8'
          }
        },
        {
          if: { hover: true, interactive: true, isControl: true },
          tokens: { iconColor: '#000000' }
        },
        {
          if: {
            focus: false,
            interactive: true,
            isControl: true,
            pressed: false
          },
          tokens: { borderColor: 'rgba(0, 0, 0, 0)', borderWidth: 2 }
        },
        {
          if: {
            hover: true,
            interactive: true,
            isControl: true,
            selected: true
          },
          tokens: {
            iconBackgroundColor: '#c9c8c8',
            iconColor: '#000000',
            inputBackgroundColor: '#c9c8c8'
          }
        },
        { if: { borderRadius: 'none' }, tokens: { borderRadius: 0 } },
        { if: { borderRadius: 'small' }, tokens: { borderRadius: 4 } },
        { if: { borderRadius: 'large' }, tokens: { borderRadius: 8 } },
        {
          if: { background: 'alternative' },
          tokens: {
            backgroundColor: '#e0d8fc',
            borderRadius: 8,
            borderWidth: 0
          }
        },
        {
          if: { background: 'subtle' },
          tokens: { backgroundColor: '#a1ed00', borderWidth: 0 }
        },
        {
          if: { background: 'grid' },
          tokens: { borderColor: '#000000', borderWidth: 1 }
        },
        {
          if: { background: 'feature' },
          tokens: {
            backgroundColor: '#ffad00',
            borderRadius: 8,
            borderWidth: 0
          }
        },
        {
          if: { background: 'plain' },
          tokens: { backgroundColor: '#ffffff', borderWidth: 0 }
        },
        {
          if: { style: 'grid' },
          tokens: { borderColor: '#000000', borderWidth: 1 }
        },
        {
          if: { style: 'light' },
          tokens: { backgroundColor: '#efefef', borderWidth: 0 }
        },
        {
          if: { style: 'lighter' },
          tokens: {
            backgroundColor: '#fafafa',
            borderColor: '#efefef',
            borderWidth: 2
          }
        },
        {
          if: { style: 'lightest' },
          tokens: { backgroundColor: '#ffffff', borderWidth: 0 }
        },
        {
          if: { style: 'dark' },
          tokens: { backgroundColor: '#000000', borderWidth: 0 }
        },
        {
          if: { style: 'darker' },
          tokens: { backgroundColor: '#000000', borderWidth: 0 }
        },
        {
          if: { style: 'darkest' },
          tokens: { backgroundColor: '#000000', borderWidth: 0 }
        },
        {
          if: { style: 'feature' },
          tokens: { backgroundColor: '#a1ed00', borderWidth: 0 }
        },
        {
          if: { style: 'feature2' },
          tokens: {
            backgroundColor: '#e0d8fc',
            borderRadius: 8,
            borderWidth: 0
          }
        },
        {
          if: { style: 'feature3' },
          tokens: {
            backgroundColor: '#ffad00',
            borderRadius: 8,
            borderWidth: 0
          }
        },
        {
          if: { style: 'feature4' },
          tokens: { backgroundColor: '#2dccd3', borderWidth: 0 }
        },
        {
          if: { style: 'warning' },
          tokens: {
            backgroundColor: '#fff5d2',
            borderColor: '#f8c100',
            borderWidth: 2
          }
        },
        {
          if: { style: 'error' },
          tokens: {
            backgroundColor: '#fcd3c6',
            borderColor: '#f3592b',
            borderWidth: 2
          }
        },
        {
          if: { style: 'success' },
          tokens: {
            backgroundColor: '#c5f2cc',
            borderColor: '#1c7b2b',
            borderWidth: 2
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            paddingBottom: 48,
            paddingLeft: 32,
            paddingRight: 32,
            paddingTop: 48
          }
        },
        {
          if: { interactive: true, viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            paddingBottom: 45,
            paddingLeft: 29,
            paddingRight: 29,
            paddingTop: 45
          }
        },
        {
          if: { padding: 'narrow' },
          tokens: {
            paddingBottom: 24,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 24
          }
        },
        {
          if: { interactive: true, padding: 'narrow' },
          tokens: {
            paddingBottom: 21,
            paddingLeft: 13,
            paddingRight: 13,
            paddingTop: 21
          }
        },
        {
          if: { padding: 'narrow', viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            paddingBottom: 32,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 32
          }
        },
        {
          if: {
            interactive: true,
            padding: 'narrow',
            viewport: [ 'md', 'lg', 'xl' ]
          },
          tokens: {
            paddingBottom: 29,
            paddingLeft: 13,
            paddingRight: 13,
            paddingTop: 29
          }
        },
        {
          if: { padding: 'intermediate' },
          tokens: {
            paddingBottom: 24,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24
          }
        },
        {
          if: { interactive: true, padding: 'intermediate' },
          tokens: {
            paddingBottom: 21,
            paddingLeft: 21,
            paddingRight: 21,
            paddingTop: 21
          }
        },
        {
          if: { padding: 'intermediate', viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            paddingBottom: 32,
            paddingLeft: 32,
            paddingRight: 32,
            paddingTop: 32
          }
        },
        {
          if: {
            interactive: true,
            padding: 'intermediate',
            viewport: [ 'md', 'lg', 'xl' ]
          },
          tokens: {
            paddingBottom: 29,
            paddingLeft: 29,
            paddingRight: 29,
            paddingTop: 29
          }
        },
        {
          if: { padding: 'compact' },
          tokens: {
            paddingBottom: 16,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 16
          }
        },
        {
          if: { interactive: true, padding: 'compact' },
          tokens: {
            paddingBottom: 13,
            paddingLeft: 13,
            paddingRight: 13,
            paddingTop: 13
          }
        },
        {
          if: { padding: 'custom' },
          tokens: {
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 0
          }
        },
        {
          if: {
            focus: false,
            interactive: true,
            isControl: false,
            pressed: false
          },
          tokens: { borderColor: '#ffffff', borderWidth: 2 }
        },
        {
          if: { focus: false, interactive: true, pressed: false },
          tokens: { borderColor: 'rgba(0, 0, 0, 0)', borderWidth: 2 }
        },
        {
          if: { hover: true, interactive: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderColor: 'transparent'
          }
        },
        {
          if: { focus: true, interactive: true },
          tokens: { borderColor: '#000000', borderWidth: 2 }
        },
        {
          if: { interactive: true, pressed: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderColor: '#c9c8c8',
            borderWidth: 2
          }
        },
        {
          if: { interactive: true, isControl: false, selected: true },
          tokens: {
            backgroundColor: '#efefef',
            borderColor: '#000000',
            borderWidth: 1
          }
        },
        {
          if: { hover: true, interactive: true, style: 'dark' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
        },
        {
          if: { hover: true, interactive: true, style: 'darker' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
        },
        {
          if: { hover: true, interactive: true, style: 'darkest' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
        },
        {
          if: { interactive: true, pressed: true, style: 'dark' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
        },
        {
          if: { interactive: true, pressed: true, style: 'darker' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
        },
        {
          if: { interactive: true, pressed: true, style: 'darkest' },
          tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        backgroundGradient: null,
        borderColor: '#c9c8c8',
        borderRadius: 8,
        borderWidth: 1,
        contentAlignItems: 'stretch',
        contentFlexGrow: 0,
        contentFlexShrink: 1,
        contentJustifyContent: 'flex-start',
        flex: 1,
        gradient: null,
        icon: PaletteIconCheck,
        iconBackgroundColor: '#efefef',
        iconColor: '#000000',
        iconSize: 20,
        inputBackgroundColor: '#efefef',
        inputBorderColor: 'rgba(0, 0, 0, 0)',
        inputBorderRadius: 4,
        inputBorderWidth: 0,
        inputHeight: 32,
        inputShadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: true,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        },
        inputWidth: 32,
        maxHeight: '100%',
        minWidth: null,
        overflowY: 'visible',
        paddingBottom: 32,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 32,
        shadow: null
      }
    },
    CardGroup: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'lg', 'xl' ] },
          tokens: { direction: 'row', space: 5 }
        },
        {
          if: { viewport: [ 'xs', 'sm', 'md' ] },
          tokens: { direction: 'column', fieldSpace: 3, space: 3 }
        }
      ],
      tokens: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        borderTopLeftRadius: 1,
        borderTopRightRadius: 1,
        direction: 'column',
        fieldSpace: 3,
        outlineOffset: 8,
        outlineWidth: 1,
        paddingBottom: 24,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 24,
        showIcon: true,
        space: 3
      }
    },
    Carousel: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: { showPanelTabs: false, showPreviousNextNavigation: false }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        iconBackgroundColor: '#ffffff',
        nextIcon: PaletteIconChevronRight,
        pauseIcon: PaletteIconPause,
        playIcon: PaletteIconPlay,
        previousIcon: PaletteIconChevronLeft,
        showPanelNavigation: true,
        showPanelTabs: true,
        showPreviousNextNavigation: true,
        spaceBetweenSlideAndPanelNavigation: 32,
        spaceBetweenSlideAndPreviousNextNavigation: 24,
        stepTrackerCurrentBackgroundColor: '#000000'
      }
    },
    CarouselTabsPanelItem: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: {
            borderBottomColor: '#404040',
            borderBottomWidth: 2,
            color: '#404040'
          }
        },
        {
          if: { focus: true },
          tokens: {
            borderBottomColor: '#000000',
            borderBottomWidth: 4,
            color: '#000000'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            borderBottomColor: '#666666',
            borderBottomWidth: 2,
            color: '#666666'
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { borderBottomWidth: 4 }
        },
        {
          if: { inactive: true },
          tokens: {
            borderBottomColor: '#c9c8c8',
            borderBottomWidth: 4,
            color: '#c9c8c8'
          }
        },
        {
          if: { selected: true },
          tokens: {
            borderBottomColor: '#000000',
            borderBottomWidth: 2,
            color: '#000000'
          }
        },
        {
          if: { hover: true, inverse: true },
          tokens: {
            borderBottomColor: '#ffffff',
            borderBottomWidth: 2,
            color: '#ffffff'
          }
        },
        {
          if: { focus: true, inverse: true },
          tokens: {
            borderBottomColor: '#ffffff',
            borderBottomWidth: 4,
            color: '#ffffff'
          }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: {
            borderBottomColor: '#666666',
            borderBottomWidth: 2,
            color: '#666666'
          }
        },
        { if: { inverse: true }, tokens: { color: '#ffffff' } },
        {
          if: { focus: true, inverse: true, pressed: true },
          tokens: { borderBottomWidth: 4 }
        },
        {
          if: { inactive: true, inverse: true },
          tokens: {
            borderBottomColor: '#c9c8c8',
            borderBottomWidth: 4,
            color: '#c9c8c8'
          }
        },
        {
          if: { inverse: true, selected: true },
          tokens: {
            borderBottomColor: '#ffffff',
            borderBottomWidth: 4,
            color: '#ffffff'
          }
        }
      ],
      tokens: {
        alignItems: 'flex-start',
        borderBottomColor: 'transparent',
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        color: '#000000',
        flex: 1,
        fontName: 'StagSans',
        fontScaleCap: 64,
        fontSize: 14,
        fontWeight: '600',
        justifyContent: 'flex-start',
        letterSpacing: 0,
        lineHeight: 1.45,
        paddingBottom: 16,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0
      }
    },
    CarouselThumbnail: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: { alignItems: 'flex-start', size: 32 }
        },
        { if: { hover: true }, tokens: { borderColor: '#404040' } },
        {
          if: { focus: true },
          tokens: { borderColor: '#000000', borderWidth: 2 }
        },
        {
          if: { pressed: true },
          tokens: { borderColor: '#666666', borderWidth: 2 }
        }
      ],
      tokens: {
        alignItems: 'center',
        borderColor: '#efefef',
        borderRadius: 8,
        borderWidth: 1,
        containerPaddingTop: 24,
        margin: 4,
        padding: 8,
        selectedBorderColor: '#000000',
        selectedBorderWidth: 2,
        size: 56
      }
    },
    Checkbox: {
      appearances: {
        checked: {
          description: 'Corresponds to a selected state for a checkbox or radio',
          type: 'state',
          values: [ true ]
        },
        error: { type: 'state', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { focus: true },
          tokens: { inputOutlineColor: '#000000', inputOutlineWidth: 1 }
        },
        {
          if: { hover: true },
          tokens: { inputOutlineColor: '#000000', inputOutlineWidth: 1 }
        },
        {
          if: { inactive: true },
          tokens: {
            descriptionFontColor: '#666666',
            inputBackgroundColor: '#c9c8c8',
            inputBorderColor: 'rgba(0, 0, 0, 0)',
            labelColor: '#666666'
          }
        },
        {
          if: { checked: true, inactive: true },
          tokens: { iconBackgroundColor: '#c9c8c8', iconColor: '#ffffff' }
        }
      ],
      tokens: {
        containerBackgroundColor: 'rgba(0, 0, 0, 0)',
        descriptionFontColor: '#000000',
        descriptionFontName: 'StagSans',
        descriptionFontSize: 14,
        descriptionFontWeight: '400',
        descriptionLineHeight: 1.4,
        descriptionMarginLeft: null,
        feedbackMarginBottom: 0,
        feedbackMarginTop: 12,
        feedbackPosition: 'bottom',
        icon: PaletteIconCheck,
        iconBackgroundColor: '#ffffff',
        iconColor: '#7a3dfc',
        iconSize: 14,
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#000000',
        inputBorderRadius: 0,
        inputBorderWidth: 2,
        inputHeight: 20,
        inputOutlineColor: null,
        inputOutlineOffset: 1,
        inputOutlineWidth: 0,
        inputShadow: null,
        inputWidth: 20,
        labelColor: '#000000',
        labelFontName: 'StagSans',
        labelFontSize: 16,
        labelFontWeight: '400',
        labelLineHeight: 1.5,
        labelMarginLeft: 8
      }
    },
    CheckboxCard: {
      appearances: {
        checked: {
          description: 'Corresponds to a selected state for a checkbox or radio',
          type: 'state',
          values: [ true ]
        },
        error: { type: 'state', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'lg', 'xl' ] },
          tokens: {
            fontSize: 24,
            lineHeight: 1.3,
            paddingBottom: 24,
            paddingLeft: 16,
            paddingRight: 24,
            paddingTop: 16
          }
        },
        {
          if: { hover: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderColor: '#c9c8c8',
            checkboxOuterBorderColor: 'rgba(0, 0, 0, 0)',
            checkboxOuterBorderGap: 0,
            checkboxOuterBorderWidth: 0,
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            outerBorderGap: 0,
            outerBorderWidth: 0
          }
        },
        {
          if: { checked: true },
          tokens: {
            borderColor: '#c9c8c8',
            checkboxCheckedBackgroundColor: '#7a3dfc',
            checkboxInputBorderColor: '#000000',
            checkboxInputBorderWidth: 2
          }
        },
        {
          if: { focus: true },
          tokens: {
            borderColor: '#666666',
            checkboxInputBorderColor: '#000000',
            checkboxOuterBorderColor: '#000000',
            checkboxOuterBorderGap: 2,
            checkboxOuterBorderWidth: 1,
            outerBorderColor: '#000000',
            outerBorderGap: 2,
            outerBorderWidth: 2
          }
        },
        {
          description: 'Pressed state matches hover state plus light grey background',
          if: { pressed: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderColor: '#c9c8c8',
            checkboxOuterBorderColor: 'rgba(0, 0, 0, 0)',
            checkboxOuterBorderGap: 0,
            checkboxOuterBorderWidth: 0,
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            outerBorderGap: 0,
            outerBorderWidth: 0
          }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#efefef',
            borderColor: 'transparent',
            checkboxCheckedBackgroundColor: '#c9c8c8',
            checkboxInputBackgroundColor: '#c9c8c8',
            checkboxInputBorderColor: '#c9c8c8',
            checkboxInputSize: 16,
            checkboxOuterBorderColor: '#c9c8c8',
            checkboxOuterBorderGap: 2,
            checkboxOuterBorderWidth: 1,
            color: '#666666'
          }
        },
        {
          if: { error: true },
          tokens: {
            borderColor: '#df3d0c',
            checkboxInputBorderColor: '#df3d0c',
            color: '#df3d0c'
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#c9c8c8',
        borderRadius: 4,
        borderWidth: 1,
        checkboxCheckedBackgroundColor: '#000000',
        checkboxCheckedSize: 16,
        checkboxInputBackgroundColor: '#ffffff',
        checkboxInputBorderColor: '#000000',
        checkboxInputBorderWidth: 2,
        checkboxInputOutlineColor: 'rgba(0, 0, 0, 0)',
        checkboxInputOutlineWidth: 0,
        checkboxInputSize: 24,
        checkboxOuterBorderColor: 'transparent',
        checkboxOuterBorderGap: 0,
        checkboxOuterBorderWidth: 0,
        checkboxSpace: 2,
        color: '#000000',
        contentAlignItems: 'stretch',
        contentFlexGrow: 0,
        contentFlexShrink: 1,
        contentJustifyContent: 'flex-start',
        contentSpace: 2,
        flex: 1,
        fontName: 'StagSans',
        fontSize: 20,
        fontWeight: '700',
        letterSpacing: 0,
        lineHeight: 1.4,
        minWidth: 288,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        paddingBottom: 16,
        paddingLeft: 8,
        paddingRight: 16,
        paddingTop: 12,
        shadow: null,
        textTransform: 'none'
      }
    },
    CheckboxCardGroup: {
      appearances: {
        fullWidth: {
          description: 'Makes cards always occupy the full width of the parent, regardless of viewport',
          type: 'variant',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: { direction: 'row', space: 5 }
        },
        {
          if: { fullWidth: true },
          tokens: { direction: 'column', fieldSpace: 3, space: 3 }
        }
      ],
      tokens: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        borderTopLeftRadius: 1,
        borderTopRightRadius: 1,
        direction: 'column',
        fieldSpace: 3,
        outlineOffset: 8,
        outlineWidth: 1,
        showIcon: true,
        space: 3
      }
    },
    CheckboxGroup: {
      appearances: {},
      rules: [],
      tokens: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        borderTopLeftRadius: 1,
        borderTopRightRadius: 1,
        fieldSpace: 2,
        outlineOffset: 8,
        outlineWidth: 1,
        showIcon: true,
        space: 2
      }
    },
    ChevronLink: {
      appearances: {
        alternative: { type: 'variant', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        quiet: {
          description: 'When it is true, it does not show the decoration',
          type: 'state',
          values: [ true, false ]
        },
        size: {
          description: 'Sets the size of the text and icon; these variants are shared with ChevronLink',
          type: 'variant',
          values: [ 'large', 'small', 'micro' ]
        },
        style: {
          type: 'variant',
          values: [ 'inline', 'subtle', 'feature', 'danger', 'inverse' ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { color: '#404040', iconDisplace: 4 }
        },
        { if: { pressed: true }, tokens: { color: '#666666' } },
        {
          if: { focus: true },
          tokens: { color: '#000000', outerBorderColor: '#000000' }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { color: '#666666', outerBorderColor: '#666666' }
        },
        { if: { alternative: true }, tokens: { color: '#7a3dfc' } },
        {
          if: { alternative: true, hover: true },
          tokens: { color: '#5b2bc2' }
        },
        {
          if: { alternative: true, pressed: true },
          tokens: { color: '#666666' }
        },
        {
          if: { alternative: true, focus: true },
          tokens: { color: '#7a3dfc', outerBorderColor: '#7a3dfc' }
        },
        {
          if: { alternative: true, focus: true, pressed: true },
          tokens: { color: '#666666', outerBorderColor: '#666666' }
        },
        { if: { inverse: true }, tokens: { color: '#ffffff' } },
        {
          if: { hover: true, inverse: true },
          tokens: { color: '#efefef' }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: { color: '#c9c8c8' }
        },
        {
          if: { focus: true, inverse: true },
          tokens: { color: '#ffffff', outerBorderColor: '#ffffff' }
        },
        {
          if: { focus: true, inverse: true, pressed: true },
          tokens: { color: '#c9c8c8', outerBorderColor: '#c9c8c8' }
        },
        {
          if: { size: 'large' },
          tokens: { blockLineHeight: 1.4, fontSize: 20, iconSize: 20 }
        },
        {
          if: { size: 'small' },
          tokens: {
            blockLineHeight: 1.42857142857,
            fontSize: 14,
            iconSize: 16
          }
        },
        {
          if: { size: 'micro' },
          tokens: {
            blockLineHeight: 1.33333333333,
            fontSize: 12,
            iconSize: 16
          }
        },
        {
          if: { focus: true, quiet: true },
          tokens: { color: '#000000', textLine: 'none' }
        },
        {
          if: { pressed: true, quiet: true },
          tokens: { color: '#595959', textLine: 'underline' }
        },
        {
          if: { focus: true, pressed: true, quiet: true },
          tokens: { color: '#595959', textLine: 'underline' }
        },
        { if: { style: 'inline' }, tokens: { color: '#000000' } },
        {
          if: { focus: true, style: 'inline' },
          tokens: { color: '#000000', outerBorderColor: '#000000' }
        },
        {
          if: { hover: true, style: 'inline' },
          tokens: { color: '#404040', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'inline' },
          tokens: { color: '#595959', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'inline' },
          tokens: { outerBorderColor: '#595959' }
        },
        { if: { style: 'subtle' }, tokens: { color: '#595959' } },
        {
          if: { focus: true, style: 'subtle' },
          tokens: { color: '#000000', outerBorderColor: '#000000' }
        },
        {
          if: { hover: true, style: 'subtle' },
          tokens: { color: '#404040', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'subtle' },
          tokens: { color: '#595959', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'subtle' },
          tokens: { outerBorderColor: '#595959' }
        },
        { if: { style: 'feature' }, tokens: { color: '#7a3dfc' } },
        {
          if: { focus: true, style: 'feature' },
          tokens: { color: '#7a3dfc', outerBorderColor: '#7a3dfc' }
        },
        {
          if: { hover: true, style: 'feature' },
          tokens: { color: '#5b2bc2', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'feature' },
          tokens: { color: '#595959', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'feature' },
          tokens: { outerBorderColor: '#595959' }
        },
        { if: { style: 'danger' }, tokens: { color: '#c9370b' } },
        {
          if: { focus: true, style: 'danger' },
          tokens: { color: '#c9370b', outerBorderColor: '#c9370b' }
        },
        {
          if: { hover: true, style: 'danger' },
          tokens: { color: '#c9370b', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'danger' },
          tokens: { color: '#595959', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'danger' },
          tokens: { outerBorderColor: '#595959' }
        },
        { if: { style: 'inverse' }, tokens: { color: '#ffffff' } },
        {
          if: { focus: true, style: 'inverse' },
          tokens: { color: '#ffffff', outerBorderColor: '#ffffff' }
        },
        {
          if: { hover: true, style: 'inverse' },
          tokens: { color: '#efefef', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'inverse' },
          tokens: { color: '#666666', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'inverse' },
          tokens: { outerBorderColor: '#666666' }
        },
        {
          if: { quiet: true, style: 'inline' },
          tokens: { color: '#000000', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'inline' },
          tokens: {
            color: '#000000',
            outerBorderColor: '#000000',
            textLine: 'none'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'inline' },
          tokens: { color: '#404040', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'inline' },
          tokens: { color: '#595959' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'inline' },
          tokens: { outerBorderColor: '#595959' }
        },
        {
          if: { quiet: true, style: 'subtle' },
          tokens: { color: '#595959', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'subtle' },
          tokens: {
            color: '#000000',
            outerBorderColor: '#000000',
            textLine: 'none'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'subtle' },
          tokens: { color: '#404040', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'subtle' },
          tokens: { color: '#595959' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'subtle' },
          tokens: { outerBorderColor: '#595959' }
        },
        {
          if: { quiet: true, style: 'feature' },
          tokens: { color: '#7a3dfc', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'feature' },
          tokens: {
            color: '#7a3dfc',
            outerBorderColor: '#7a3dfc',
            textLine: 'none'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'feature' },
          tokens: { color: '#5b2bc2', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'feature' },
          tokens: { color: '#595959' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'feature' },
          tokens: { outerBorderColor: '#595959' }
        },
        {
          if: { quiet: true, style: 'danger' },
          tokens: { color: '#c9370b', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'danger' },
          tokens: {
            color: '#c9370b',
            outerBorderColor: '#c9370b',
            textLine: 'none'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'danger' },
          tokens: { color: '#c9370b', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'danger' },
          tokens: { color: '#595959' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'danger' },
          tokens: { outerBorderColor: '#595959' }
        },
        {
          if: { quiet: true, style: 'inverse' },
          tokens: { color: '#ffffff', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'inverse' },
          tokens: {
            color: '#ffffff',
            outerBorderColor: '#ffffff',
            textLine: 'none'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'inverse' },
          tokens: { color: '#efefef', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'inverse' },
          tokens: { color: '#666666' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'inverse' },
          tokens: { outerBorderColor: '#666666' }
        }
      ],
      tokens: {
        blockLineHeight: 1.5,
        color: '#000000',
        fontSize: 16,
        iconDisplace: 0,
        iconSize: 16,
        iconSpace: 1,
        leftIcon: PaletteIconChevronLeft,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        rightIcon: PaletteIconChevronRight,
        textLine: 'none'
      }
    },
    ColourToggle: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: {
            bubbleBorderColor: '#c9c8c8',
            bubbleBorderRadius: 45,
            bubbleBorderWidth: 1
          }
        },
        {
          if: { focus: true },
          tokens: {
            bubbleBorderColor: '#7a3dfc',
            bubbleBorderRadius: 45,
            bubbleBorderWidth: 1
          }
        },
        {
          if: { pressed: true },
          tokens: {
            bubbleBorderColor: '#595959',
            bubbleBorderRadius: 45,
            bubbleBorderWidth: 1
          }
        },
        {
          if: { selected: true },
          tokens: {
            bubbleBorderColor: '#000000',
            bubbleBorderRadius: 45,
            bubbleBorderWidth: 1
          }
        }
      ],
      tokens: {
        borderColor: '#c9c8c8',
        borderRadius: 45,
        borderWidth: 1,
        bubbleBorderColor: 'rgba(0, 0, 0, 0)',
        bubbleBorderRadius: 0,
        bubbleBorderWidth: 0,
        innerBubbleBorderRadius: 45,
        innerBubbleHeight: 40,
        innerBubbleWidth: 40,
        outerBubbleContentAlignItems: 'center',
        outerBubbleHeight: 48,
        outerBubbleJustifyContent: 'center',
        outerBubbleWidth: 48,
        shadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: true,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        },
        space: 2
      }
    },
    Countdown: {
      appearances: {
        feature: { type: 'variant', values: [ true ] },
        inverse: { type: 'variant', values: [ true ] },
        label: { type: 'variant', values: [ true ] },
        large: { type: 'variant', values: [ true ] },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs' ] },
          tokens: {
            containerPaddingBottomTop: 16,
            containerPaddingLeftRight: 24,
            labelFontSize: 16,
            labelLineHeight: 1.5,
            textLineHeight: 1.5
          }
        },
        {
          if: { feature: true },
          tokens: {
            containerBorderColor: '#000000',
            labelBorderColor: '#000000',
            textFontSize: 70,
            textLineHeight: 1.2,
            textTimerFontName: 'StagSans',
            textTimerFontWeight: '700'
          }
        },
        {
          if: { large: true },
          tokens: {
            labelFontName: 'StagSans',
            labelFontSize: 16,
            labelFontWeight: '400',
            textFontSize: 70,
            textLineHeight: 1.2,
            textTimerFontName: 'StagSans',
            textTimerFontWeight: '700'
          }
        },
        {
          if: { large: true, viewport: [ 'xs' ] },
          tokens: { textFontSize: 44, textLineHeight: 1.22222222222 }
        },
        {
          if: { feature: true, viewport: [ 'xs' ] },
          tokens: { textFontSize: 44 }
        },
        {
          if: { inverse: true },
          tokens: {
            containerBorderColor: '#ffffff',
            labelBorderColor: '#ffffff'
          }
        }
      ],
      tokens: {
        containerBorderColor: 'rgba(0, 0, 0, 0)',
        containerBorderRadius: 6,
        containerBorderWidth: 2,
        containerGradient: null,
        containerInverseBorder: 2,
        containerInverseBorderColor: '#ffffff',
        containerPaddingBottomTop: 48,
        containerPaddingLeftRight: 64,
        inverseBorderColor: null,
        labelBorderColor: null,
        labelFontName: 'StagSans',
        labelFontSize: 16,
        labelFontWeight: '400',
        labelLineHeight: 1.5,
        textFontSize: 16,
        textLineHeight: 1.5,
        textTimerFontName: 'StagSans',
        textTimerFontWeight: '400'
      }
    },
    DatePicker: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs' ] },
          tokens: {
            calendarMonthCaptionFontName: 'StagSans',
            calendarMonthCaptionFontSize: 14,
            calendarMonthCaptionFontWeight: '600',
            calendarMonthCaptionLineHeight: 1.72
          }
        }
      ],
      tokens: {
        calendarBackgroundColor: '#ffffff',
        calendarDayBlockedCalendarHoverBackground: '#efefef',
        calendarDayBlockedCalendarHoverColor: '#666666',
        calendarDayDefaultBackgroundColor: '#ffffff',
        calendarDayDefaultBorder: 1,
        calendarDayDefaultBorderColor: '#c9c8c8',
        calendarDayDefaultCalendarDaySelectedHoverBackground: '#ffffff',
        calendarDayDefaultCalendarDaySelectedHoverBeforeBackground: '#7a3dfc',
        calendarDayDefaultCalendarDaySelectedHoverColor: '#ffffff',
        calendarDayDefaultColor: '#000000',
        calendarDayDefaultFontName: 'StagSans',
        calendarDayDefaultFontSize: 14,
        calendarDayDefaultFontWeight: '400',
        calendarDaySelectedDisabledBackground: '#efefef',
        calendarDaySelectedDisabledColor: '#ffffff',
        calendarDaySelectedDisabledContentBackgroundColor: '#c9c8c8',
        calendarDaySelectedFocusBeforeBackground: '#ffffff',
        calendarDaySelectedHoverBackground: '#ffffff',
        calendarDaySelectedHoverBeforeBackground: '#ffffff',
        calendarDaySelectedHoverBeforeBorderColor: '#7a3dfc',
        calendarDaySelectedHoverBorderColor: '#c9c8c8',
        calendarDaySelectedHoverColor: '#000000',
        calendarMonthCaptionColor: '#000000',
        calendarMonthCaptionFontName: 'StagSans',
        calendarMonthCaptionFontSize: 20,
        calendarMonthCaptionFontWeight: '700',
        calendarMonthCaptionLineHeight: 1.2,
        calendarMonthCaptionPaddingBottom: 48,
        dateInputStrokeColor: '#666666',
        dayPickerNavigationButtonPadding: 12,
        dayPickerWeekHeaderColor: '#000000',
        dayPickerWeekHeaderFontName: 'StagSans',
        dayPickerWeekHeaderFontWeight: '700',
        dayPickerWeekHeaderLineHeight: 1.14285714286,
        dayPickerWeekHeaderSmall: 14,
        hiddenInputFieldContainerHeight: 0,
        hiddenInputFieldContainerWidth: 0,
        invalidInputMixin: null,
        nextIcon: PaletteIconChevronRight,
        previousIcon: PaletteIconChevronLeft,
        singleDatePickerBorderColor: '#666666',
        singleDatePickerLeftRight: 16,
        singleDatePickerPaddingTopBottom: 8,
        singleDatePickerRadius: 4,
        validInputMixin: null
      }
    },
    Disclaimer: {
      appearances: {},
      rules: [],
      tokens: {
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 12,
        fontWeight: '400',
        lineHeight: 1.33333333333
      }
    },
    Divider: {
      appearances: {
        decorative: {
          description: 'Use a decorative divider to highlight an element. Non-decorative dividers are for clearly identifying separation of content.',
          type: 'variant',
          values: [ true ]
        },
        inverse: { type: 'variant', values: [ true ] },
        weight: { type: 'variant', values: [ 'thick' ] }
      },
      rules: [
        { if: { weight: 'thick' }, tokens: { width: 2 } },
        { if: { decorative: true }, tokens: { color: '#000000' } },
        {
          if: { decorative: true, weight: 'thick' },
          tokens: { color: '#000000', width: 2 }
        },
        { if: { inverse: true }, tokens: { color: '#ffffff' } },
        {
          if: { inverse: true, weight: 'thick' },
          tokens: { color: '#ffffff', width: 2 }
        }
      ],
      tokens: { color: '#c9c8c8', width: 1 }
    },
    DownloadApp: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { focus: true },
          tokens: { borderColor: '#000000', borderRadius: 4 }
        },
        {
          if: { hover: true },
          tokens: { borderColor: '#666666', borderRadius: 4 }
        },
        {
          if: { pressed: true },
          tokens: { borderColor: '#666666', borderRadius: 4 }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { borderColor: '#666666', borderRadius: 4 }
        }
      ],
      tokens: {
        androidENIcon: PaletteIconAndroidEN,
        androidFRIcon: PaletteIconAndroidFR,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderGap: 2,
        borderRadius: 0,
        borderWidth: 1,
        iosENIcon: PaletteIconIOSEN,
        iosFRIcon: PaletteIconIOSFR,
        padding: 1
      }
    },
    ExpandCollapse: {
      appearances: {},
      rules: [],
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        borderStyle: 'solid',
        borderWidth: 0
      }
    },
    ExpandCollapseControl: {
      appearances: {
        compact: { type: 'variant', values: [ true ] },
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        mini: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { mini: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: null,
            icon: PaletteIconChevronDown,
            iconColor: '#000000',
            iconGap: 8,
            iconPaddingTop: 4,
            iconPosition: 'left',
            iconSize: 16,
            justifyContent: 'flex-start',
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 0,
            verticalAlign: 'middle'
          }
        },
        {
          if: { expanded: true },
          tokens: { icon: PaletteIconChevronUp }
        },
        {
          if: { focus: true },
          tokens: {
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
            borderColor: '#000000',
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            borderWidth: 2
          }
        },
        {
          if: { focus: true, mini: true },
          tokens: {
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
            borderColor: '#000000',
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            borderWidth: null
          }
        },
        {
          if: { hover: true },
          tokens: { backgroundColor: 'rgba(0, 0, 0, 0.1)', iconPaddingTop: 8 }
        },
        {
          if: { expanded: true, hover: true },
          tokens: { backgroundColor: 'rgba(0, 0, 0, 0.1)', iconPaddingTop: 0 }
        },
        {
          if: { pressed: true },
          tokens: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
        },
        {
          if: { focus: true, pressed: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
            borderColor: '#000000',
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            borderWidth: 2
          }
        },
        {
          if: { focus: true, mini: true, pressed: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
            borderColor: '#000000',
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            borderWidth: null
          }
        },
        { if: { compact: true }, tokens: {} }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderWidth: 2,
        icon: PaletteIconChevronDown,
        iconColor: '#000000',
        iconGap: 8,
        iconPaddingTop: 4,
        iconPosition: 'right',
        iconSize: 16,
        justifyContent: 'space-between',
        paddingBottom: 14,
        paddingLeft: 22,
        paddingRight: 22,
        paddingTop: 14,
        textLine: 'none',
        verticalAlign: 'middle'
      }
    },
    ExpandCollapseMini: { appearances: {}, rules: [], tokens: { borderWidth: 0 } },
    ExpandCollapseMiniControl: {
      appearances: {
        alternative: {
          description: 'Replaces the default green colour with black',
          type: 'variant',
          values: [ true ]
        },
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        inverse: {
          description: 'Replaces the default green colour with white. Useful for dark backgrounds.',
          type: 'variant',
          values: [ true ]
        },
        quiet: {
          description: 'When it is true, it does not show the decoration',
          type: 'state',
          values: [ true, false ]
        },
        size: { type: 'variant', values: [ 'micro', 'small', 'large' ] }
      },
      rules: [
        {
          if: { expanded: true },
          tokens: { icon: PaletteIconChevronUp }
        },
        { if: { alternative: true }, tokens: { color: '#666666' } },
        {
          if: { inverse: true },
          tokens: { color: '#ffffff', iconColor: '#ffffff' }
        },
        {
          if: { size: 'micro' },
          tokens: { fontSize: 12, iconSize: 16, lineHeight: 1.33333333333 }
        },
        {
          if: { size: 'small' },
          tokens: { fontSize: 14, iconSize: 16, lineHeight: 1.42857142857 }
        },
        {
          if: { size: 'large' },
          tokens: { fontSize: 20, iconSize: 24, lineHeight: 1.4 }
        },
        { if: { quiet: true }, tokens: { textLine: 'none' } },
        {
          if: { alternative: true, quiet: true },
          tokens: { color: '#666666', textLine: 'none' }
        },
        {
          if: { inverse: true, quiet: true },
          tokens: { color: '#ffffff', iconColor: '#ffffff', textLine: 'none' }
        }
      ],
      tokens: {
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0,
        color: '#000000',
        fontSize: 16,
        icon: PaletteIconChevronDown,
        iconColor: '#000000',
        iconGap: 8,
        iconPaddingTop: 4,
        iconPosition: 'left',
        iconSize: 16,
        justifyContent: 'flex-start',
        lineHeight: 1.5,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        size: 4,
        textLine: 'none',
        verticalAlign: 'middle'
      }
    },
    ExpandCollapsePanel: {
      appearances: {
        compact: { type: 'variant', values: [ true ] },
        mini: { type: 'variant', values: [ true ] }
      },
      rules: [
        { if: { compact: true }, tokens: {} },
        {
          if: { mini: true },
          tokens: {
            borderColor: 'rgba(0, 0, 0, 0)',
            contentPaddingBottom: 0,
            contentPaddingLeft: 0,
            contentPaddingRight: 0,
            contentPaddingTop: 0,
            contentPanelBackgroundColor: 'rgba(0, 0, 0, 0)',
            contentPanelPaddingBottom: 0,
            contentPanelPaddingTop: 0,
            marginBottom: 0
          }
        }
      ],
      tokens: {
        borderColor: '#efefef',
        borderRadius: 4,
        borderWidth: 1,
        collapseDuration: 250,
        contentPaddingBottom: 16,
        contentPaddingLeft: 16,
        contentPaddingRight: 16,
        contentPaddingTop: 16,
        contentPanelBackgroundColor: '#efefef',
        contentPanelBorderColor: 'rgba(0, 0, 0, 0)',
        contentPanelBorderWidth: 0,
        contentPanelFontColor: '#000000',
        contentPanelFontName: 'StagSans',
        contentPanelFontSize: 16,
        contentPanelFontWeight: '700',
        contentPanelLineHeight: 1.5,
        contentPanelPaddingBottom: 16,
        contentPanelPaddingLeft: 24,
        contentPanelPaddingRight: 24,
        contentPanelPaddingTop: 16,
        expandDividerColor: null,
        expandDividerWidth: null,
        expandDuration: 300,
        marginBottom: 8
      }
    },
    Feedback: {
      appearances: {
        icon: { type: 'variant', values: [ true ] },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success', 'warning', 'feature' ]
        }
      },
      rules: [
        {
          if: { validation: 'error' },
          tokens: { backgroundColor: '#fcd3c6' }
        },
        {
          if: { validation: 'success' },
          tokens: { backgroundColor: '#c5f2cc' }
        },
        {
          if: { icon: true, validation: 'success' },
          tokens: {
            backgroundColor: '#c5f2cc',
            icon: PaletteIconCheckCircleFilled,
            iconColor: '#1c7b2b'
          }
        },
        {
          if: { icon: true, validation: 'error' },
          tokens: {
            backgroundColor: '#fcd3c6',
            icon: PaletteIconExclamationOctagon,
            iconColor: '#c9370b'
          }
        }
      ],
      tokens: {
        backgroundColor: '#efefef',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 0,
        borderWidth: 0,
        color: '#000000',
        contentFontSize: 16,
        fontName: 'StagSans',
        fontWeight: '400',
        icon: null,
        iconColor: 'rgba(0, 0, 0, 0)',
        iconGap: 8,
        iconSize: 20,
        lineHeight: 1.5,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        space: 2,
        titleFontSize: 16
      }
    },
    Fieldset: {
      appearances: { error: { type: 'variant', values: [ true ] } },
      rules: [ { if: { error: true }, tokens: { outlineColor: '#ee2c74' } } ],
      tokens: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        outlineColor: 'rgba(0, 0, 0, 0)',
        outlineOffset: null,
        outlineWidth: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0
      }
    },
    FileUpload: {
      appearances: {},
      rules: [],
      tokens: {
        buttonBackgroundColor: null,
        buttonBorderColor: null,
        buttonBorderRadius: null,
        buttonBorderWidth: null,
        buttonHeight: null,
        buttonMinWidth: null,
        buttonTextColor: null,
        buttonWidth: null,
        notificationBackgroundColor: null,
        notificationBorderColor: null,
        notificationBorderRadius: null,
        notificationDismissButtonGap: null,
        notificationDismissIcon: null,
        notificationDismissIconColor: null,
        notificationIcon: null,
        notificationIconColor: null,
        notificationIconGap: null,
        notificationIconSize: null,
        notificationTextColor: '#000000'
      }
    },
    Footnote: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs' ] },
          tokens: {
            footnoteBodyPaddingBottom: 32,
            footnoteBodyPaddingLeft: 16,
            footnoteBodyPaddingRight: 16,
            footnoteBodyPaddingTop: 0,
            footnoteHeaderPaddingBottom: 16,
            footnoteHeaderPaddingLeft: 16,
            footnoteHeaderPaddingRight: 4,
            footnoteHeaderPaddingTop: 16
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            footnoteBodyPaddingBottom: 40,
            footnoteBodyPaddingLeft: 16,
            footnoteBodyPaddingRight: 16,
            footnoteBodyPaddingTop: 0,
            footnoteHeaderPaddingBottom: 24,
            footnoteHeaderPaddingLeft: 16,
            footnoteHeaderPaddingRight: 4,
            footnoteHeaderPaddingTop: 24
          }
        }
      ],
      tokens: {
        closeButtonBackgroundColor: '#ffffff',
        closeButtonBorderColor: '#000000',
        closeButtonBorderSize: 0,
        closeButtonHeight: 16,
        closeButtonIconSize: 16,
        closeButtonMarginBottom: 4,
        closeButtonMarginLeft: 4,
        closeButtonMarginRight: 12,
        closeButtonMarginTop: 4,
        closeButtonWidth: 16,
        closeIcon: PaletteIconClose,
        footnoteBackground: '#ffffff',
        footnoteBodyBackground: '#ffffff',
        footnoteBodyPaddingBottom: 40,
        footnoteBodyPaddingLeft: 16,
        footnoteBodyPaddingRight: 16,
        footnoteBodyPaddingTop: 0,
        footnoteBorderColorMd: '#c9c8c8',
        footnoteBorderTopSizeMd: 1,
        footnoteHeaderPaddingBottom: 24,
        footnoteHeaderPaddingLeft: 16,
        footnoteHeaderPaddingRight: 4,
        footnoteHeaderPaddingTop: 24,
        headerFontName: 'StagSans',
        headerFontSize: 16,
        headerFontWeight: '700',
        headerLineHeight: 1.25,
        headerMargin: 16,
        listItemColor: '#000000',
        listItemFontName: 'StagSans',
        listItemFontSize: 14,
        listItemFontWeight: '400',
        listItemLineHeight: 1.42857142857,
        listItemMarkerFontSize: 14,
        listItemMarkerLineHeight: 1.45,
        listItemPaddingLeft: 8,
        listPaddingLeft: 32
      }
    },
    FootnoteLink: {
      appearances: {
        size: {
          type: 'variant',
          values: [
            'micro',    'small',
            'medium',   'large',
            'h1',       'h2',
            'h3',       'h4',
            'h5',       'h6',
            'display1', 'display2'
          ]
        }
      },
      rules: [
        {
          if: { size: 'display1' },
          tokens: { fontSize: 20, lineHeight: 1.2 }
        },
        {
          if: { size: 'display2' },
          tokens: { fontSize: 20, lineHeight: 1.2 }
        },
        {
          if: { size: 'h1' },
          tokens: { fontSize: 20, lineHeight: 1.2 }
        },
        {
          if: { size: 'h2' },
          tokens: { fontSize: 20, lineHeight: 1.2 }
        },
        { if: { size: 'h3' }, tokens: { fontSize: 14, lineHeight: 1 } },
        { if: { size: 'h4' }, tokens: { fontSize: 14, lineHeight: 1 } },
        { if: { size: 'h5' }, tokens: { fontSize: 14, lineHeight: 1 } },
        { if: { size: 'h6' }, tokens: { fontSize: 14, lineHeight: 1 } },
        {
          if: { size: 'micro' },
          tokens: { fontSize: 12, lineHeight: 1 }
        },
        {
          if: { size: 'small' },
          tokens: { fontSize: 12, lineHeight: 1 }
        },
        {
          if: { size: 'medium' },
          tokens: { fontSize: 12, lineHeight: 1 }
        },
        {
          if: { size: 'large' },
          tokens: { fontSize: 12, lineHeight: 1 }
        }
      ],
      tokens: {
        color: null,
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 1,
        paddingLeft: 2,
        paddingRight: 2
      }
    },
    HorizontalScrollButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: {
            backgroundColor: '#000000',
            borderColor: '#000000',
            iconColor: '#ffffff'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#404040',
            borderColor: '#404040',
            iconColor: '#ffffff'
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#000000',
        borderRadius: 32,
        borderWidth: 1,
        iconColor: '#000000',
        iconScale: 1,
        iconSize: 16,
        iconTranslateX: 0,
        iconTranslateY: 0,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        padding: 8,
        shadow: null
      }
    },
    Icon: {
      appearances: {
        background: { type: 'variant', values: [ true ] },
        color: {
          type: 'variant',
          values: [
            'brand',   'subtle',
            'offer',   'success',
            'danger',  'warning',
            'inverse'
          ]
        },
        padding: {
          type: 'variant',
          values: [ 'micro', 'small', 'medium', 'large', 'extraLarge' ]
        },
        size: {
          type: 'variant',
          values: [ 'micro', 'small', 'large', 'extraLarge' ]
        },
        status: {
          description: 'Uses icon colour to communicate meaning to the user',
          type: 'variant',
          values: [ 'success', 'error' ]
        },
        style: {
          type: 'variant',
          values: [ 'default', 'brand', 'dark', 'light' ]
        }
      },
      rules: [
        { if: { padding: 'micro' }, tokens: { padding: 4, width: 4 } },
        { if: { padding: 'small' }, tokens: { padding: 4, width: 8 } },
        {
          if: { padding: 'medium' },
          tokens: { padding: 4, width: 16 }
        },
        { if: { padding: 'large' }, tokens: { padding: 4, width: 24 } },
        {
          if: { padding: 'extraLarge' },
          tokens: { padding: 4, width: 32 }
        },
        {
          if: { background: true },
          tokens: {
            backgroundColor: '#efefef',
            borderRadius: 45,
            padding: 4,
            width: 8
          }
        },
        {
          if: { background: true, padding: 'micro' },
          tokens: {
            backgroundColor: '#efefef',
            borderRadius: 45,
            padding: 4,
            width: 4
          }
        },
        {
          if: { background: true, padding: 'small' },
          tokens: {
            backgroundColor: '#efefef',
            borderRadius: 45,
            padding: 4,
            width: 8
          }
        },
        {
          if: { background: true, padding: 'medium' },
          tokens: {
            backgroundColor: '#efefef',
            borderRadius: 45,
            padding: 4,
            width: 16
          }
        },
        {
          if: { background: true, padding: 'large' },
          tokens: {
            backgroundColor: '#efefef',
            borderRadius: 45,
            padding: 4,
            width: 24
          }
        },
        {
          if: { background: true, padding: 'extraLarge' },
          tokens: {
            backgroundColor: '#efefef',
            borderRadius: 45,
            padding: 4,
            width: 32
          }
        },
        {
          if: { style: 'default' },
          tokens: { backgroundColor: '#efefef', borderRadius: 45, padding: 4 }
        },
        {
          if: { style: 'brand' },
          tokens: { backgroundColor: '#ff0076', borderRadius: 45, padding: 4 }
        },
        {
          if: { style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { style: 'light' },
          tokens: { backgroundColor: '#ffffff', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'micro', style: 'default' },
          tokens: { backgroundColor: '#efefef', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'small', style: 'default' },
          tokens: { backgroundColor: '#efefef', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'medium', style: 'default' },
          tokens: { backgroundColor: '#efefef', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'large', style: 'default' },
          tokens: { backgroundColor: '#efefef', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'extraLarge', style: 'default' },
          tokens: { backgroundColor: '#efefef', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'micro', style: 'brand' },
          tokens: { backgroundColor: '#ff0076', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'small', style: 'brand' },
          tokens: { backgroundColor: '#ff0076', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'medium', style: 'brand' },
          tokens: { backgroundColor: '#ff0076', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'large', style: 'brand' },
          tokens: { backgroundColor: '#ff0076', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'extraLarge', style: 'brand' },
          tokens: { backgroundColor: '#ff0076', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'micro', style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'small', style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'medium', style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'large', style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'extraLarge', style: 'dark' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderRadius: 45,
            padding: 4
          }
        },
        {
          if: { padding: 'micro', style: 'light' },
          tokens: { backgroundColor: '#ffffff', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'small', style: 'light' },
          tokens: { backgroundColor: '#ffffff', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'medium', style: 'light' },
          tokens: { backgroundColor: '#ffffff', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'large', style: 'light' },
          tokens: { backgroundColor: '#ffffff', borderRadius: 45, padding: 4 }
        },
        {
          if: { padding: 'extraLarge', style: 'light' },
          tokens: { backgroundColor: '#ffffff', borderRadius: 45, padding: 4 }
        },
        { if: { size: 'micro' }, tokens: { size: 16 } },
        { if: { size: 'small' }, tokens: { size: 20 } },
        { if: { size: 'large' }, tokens: { size: 32 } },
        { if: { size: 'extraLarge' }, tokens: { size: 48 } },
        { if: { color: 'brand' }, tokens: { color: '#ff0076' } },
        { if: { color: 'subtle' }, tokens: { color: '#666666' } },
        { if: { color: 'offer' }, tokens: { color: '#7a3dfc' } },
        { if: { color: 'success' }, tokens: { color: '#1c7b2b' } },
        { if: { color: 'danger' }, tokens: { color: '#c9370b' } },
        { if: { color: 'warning' }, tokens: { color: '#c9370b' } },
        { if: { color: 'inverse' }, tokens: { color: '#ffffff' } },
        { if: { status: 'success' }, tokens: { color: '#1c7b2b' } },
        { if: { status: 'error' }, tokens: { color: '#c9370b' } }
      ],
      tokens: {
        backgroundColor: 'transparent',
        borderRadius: 0,
        color: '#000000',
        gradient: null,
        padding: 0,
        paddingTop: 0,
        scale: 1,
        size: 24,
        translateX: 0,
        translateY: 0,
        width: 0
      }
    },
    IconButton: {
      appearances: {
        action: {
          type: 'variant',
          values: [
            'add',      'close',
            'expand',   'moveDown',
            'moveLeft', 'moveRight',
            'moveUp',   'play',
            'subtract'
          ]
        },
        compact: {
          description: 'Without the outer border gap',
          type: 'variant',
          values: [ true ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        inverse: {
          description: 'For use on dark backgrounds',
          type: 'variant',
          values: [ true ]
        },
        password: {
          description: 'Password masked or not',
          type: 'variant',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        raised: {
          description: 'Uses shadow and background colour to appear raised above the page',
          type: 'variant',
          values: [ true ]
        },
        size: { type: 'variant', values: [ 'small', 'large' ] }
      },
      rules: [
        { if: { action: 'add' }, tokens: { icon: PaletteIconAdd } },
        {
          if: { action: 'subtract' },
          tokens: { icon: PaletteIconSubtract }
        },
        {
          if: { action: 'close' },
          tokens: { icon: PaletteIconClose }
        },
        {
          if: { action: 'expand' },
          tokens: { icon: PaletteIconExpand }
        },
        {
          if: { action: 'moveDown' },
          tokens: { icon: PaletteIconChevronDown }
        },
        {
          if: { action: 'moveLeft' },
          tokens: { icon: PaletteIconChevronLeft }
        },
        {
          if: { action: 'moveRight' },
          tokens: { icon: PaletteIconChevronRight }
        },
        {
          if: { action: 'moveUp' },
          tokens: { icon: PaletteIconChevronUp }
        },
        {
          if: { action: 'play' },
          tokens: { icon: PaletteIconPlayVideo }
        },
        { if: { action: 'add' }, tokens: { icon: PaletteIconAdd } },
        {
          if: { action: 'subtract' },
          tokens: { icon: PaletteIconSubtract }
        },
        {
          if: { action: 'close' },
          tokens: { icon: PaletteIconClose }
        },
        {
          if: { action: 'expand' },
          tokens: { icon: PaletteIconExpand }
        },
        {
          if: { action: 'moveDown' },
          tokens: { icon: PaletteIconChevronDown }
        },
        {
          if: { action: 'moveLeft' },
          tokens: { icon: PaletteIconChevronLeft }
        },
        {
          if: { action: 'moveRight' },
          tokens: { icon: PaletteIconChevronRight }
        },
        {
          if: { action: 'moveUp' },
          tokens: { icon: PaletteIconChevronUp }
        },
        {
          if: { action: 'play' },
          tokens: { icon: PaletteIconPlayVideo }
        },
        {
          if: { inverse: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(0, 0, 0, 0)',
            iconColor: '#ffffff'
          }
        },
        {
          if: { hover: true },
          tokens: {
            backgroundColor: '#000000',
            iconColor: '#ffffff',
            iconScale: 1.1
          }
        },
        {
          if: { hover: true, inverse: true },
          tokens: { backgroundColor: '#ffffff', iconColor: '#000000' }
        },
        {
          if: { focus: true },
          tokens: {
            backgroundColor: 'transparent',
            borderColor: '#000000',
            iconColor: '#000000',
            outerBorderColor: 'rgba(0, 0, 0, 0)'
          }
        },
        {
          if: { focus: true, inverse: true },
          tokens: {
            backgroundColor: 'transparent',
            borderColor: '#ffffff',
            iconColor: '#ffffff',
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            outerBorderWidth: 0
          }
        },
        {
          if: { password: true },
          tokens: { borderColor: 'transparent' }
        },
        {
          if: { focus: true, password: true },
          tokens: {
            borderColor: '#000000',
            borderWidth: 3,
            outerBorderWidth: 0
          }
        },
        {
          if: { inactive: null, pressed: true },
          tokens: { backgroundColor: '#404040', iconColor: '#666666' }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            borderColor: '#c9c8c8',
            iconColor: '#000000',
            outerBorderWidth: 0
          }
        },
        {
          if: { password: true, pressed: true },
          tokens: {
            backgroundColor: '#000000',
            borderColor: '#000000',
            iconColor: '#000000',
            outerBorderGap: 0
          }
        },
        {
          if: { size: 'large' },
          tokens: { iconSize: 24, padding: 12 }
        },
        { if: { size: 'small' }, tokens: { iconSize: 16, padding: 4 } },
        {
          description: 'Raised IconButtons follow different design patterns to other variants',
          if: { raised: true },
          tokens: {
            backgroundColor: '#ffffff',
            borderColor: '#000000',
            shadow: {
              blur: 2,
              color: 'rgba(0, 0, 0, 0.2)',
              inset: false,
              offsetX: 0,
              offsetY: 2,
              spread: 0
            }
          }
        },
        {
          if: { hover: true, raised: true },
          tokens: { backgroundColor: '#000000', iconColor: '#ffffff' }
        },
        {
          if: { raised: true, size: 'large' },
          tokens: { iconSize: 24, padding: 12 }
        },
        { if: { raised: true, size: 'small' }, tokens: { padding: 8 } },
        {
          if: { focus: true, raised: true },
          tokens: { borderWidth: 3 }
        },
        {
          if: { pressed: true, raised: true },
          tokens: {
            backgroundColor: '#404040',
            borderColor: '#404040',
            iconColor: '#666666'
          }
        },
        { if: { compact: true }, tokens: { outerBorderGap: 0 } },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#efefef',
            iconColor: '#c9c8c8',
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            outerBorderWidth: 0
          }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderBottomLeftRadius: null,
        borderBottomRightRadius: null,
        borderBottomWidth: null,
        borderColor: 'transparent',
        borderLeftWidth: null,
        borderRadius: 99999999999999,
        borderRightWidth: null,
        borderTopLeftRadius: null,
        borderTopRightRadius: null,
        borderTopWidth: null,
        borderWidth: 1,
        height: null,
        icon: PaletteIconAdd,
        iconColor: '#000000',
        iconScale: 1,
        iconSize: 16,
        iconTranslateX: 0,
        iconTranslateY: 0,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        padding: 4,
        shadow: null,
        width: null
      }
    },
    Image: { appearances: {}, rules: [], tokens: { borderRadius: null } },
    InputLabel: {
      appearances: {},
      rules: [],
      tokens: {
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        gap: 8,
        hintColor: '#000000',
        hintFontName: 'StagSans',
        hintFontSize: 14,
        hintFontWeight: '400',
        hintLineHeight: 1.42857142857,
        lineHeight: 1.5
      }
    },
    InputSupports: { appearances: {}, rules: [], tokens: { space: 1 } },
    Link: {
      appearances: {
        alternative: { type: 'variant', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        iconPosition: {
          description: 'Theme styles to be applied to icon links depending on where the icon is in relation to the link text',
          type: 'state',
          values: [ 'left', 'right', 'inline' ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        quiet: {
          description: 'When it is true, it does not show the decoration',
          type: 'state',
          values: [ true, false ]
        },
        size: {
          description: 'Text sizes for block links; similar but not always identical to Typography sizes.',
          type: 'variant',
          values: [ 'micro', 'small', 'large' ]
        },
        style: {
          type: 'variant',
          values: [ 'inline', 'subtle', 'feature', 'danger', 'inverse' ]
        }
      },
      rules: [
        { if: { iconPosition: 'left' }, tokens: { iconSpace: 2 } },
        { if: { iconPosition: 'right' }, tokens: { iconSpace: 1 } },
        {
          if: { focus: true },
          tokens: {
            color: '#000000',
            outerBorderColor: '#000000',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { color: '#666666', outerBorderColor: '#666666' }
        },
        {
          if: { hover: true },
          tokens: { color: '#404040', textLine: 'none' }
        },
        {
          if: { pressed: true },
          tokens: { color: '#666666', textLine: 'none' }
        },
        { if: { alternative: true }, tokens: { color: '#595959' } },
        {
          if: { alternative: true, focus: true },
          tokens: { color: '#595959', outerBorderColor: '#595959' }
        },
        {
          if: { alternative: true, hover: true },
          tokens: { color: '#404040' }
        },
        {
          if: { alternative: true, pressed: true },
          tokens: { color: '#404040' }
        },
        {
          if: { alternative: true, focus: true, pressed: true },
          tokens: { color: '#404040', outerBorderColor: '#404040' }
        },
        { if: { inverse: true }, tokens: { color: '#ffffff' } },
        {
          if: { focus: true, inverse: true },
          tokens: { color: '#ffffff', outerBorderColor: '#ffffff' }
        },
        {
          if: { focus: true, inverse: true, pressed: true },
          tokens: { color: '#c9c8c8', outerBorderColor: '#c9c8c8' }
        },
        {
          if: { hover: true, inverse: true },
          tokens: { color: '#efefef' }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: { color: '#c9c8c8' }
        },
        {
          if: { size: 'micro' },
          tokens: {
            blockFontName: 'StagSans',
            blockFontSize: 12,
            blockFontWeight: '600',
            blockLineHeight: 1.33333333333,
            iconSize: 12
          }
        },
        {
          if: { size: 'small' },
          tokens: {
            blockFontSize: 14,
            blockLineHeight: 1.42857142857,
            iconSize: 14
          }
        },
        {
          if: { size: 'large' },
          tokens: { blockFontSize: 20, blockLineHeight: 1.4, iconSize: 24 }
        },
        { if: { quiet: true }, tokens: { textLine: 'none' } },
        {
          if: { hover: true, quiet: true },
          tokens: { color: '#404040', textLine: 'underline' }
        },
        {
          if: { focus: true, quiet: true },
          tokens: { color: '#000000', textLine: 'none' }
        },
        {
          if: { pressed: true, quiet: true },
          tokens: { color: '#595959', textLine: 'underline' }
        },
        {
          if: { focus: true, pressed: true, quiet: true },
          tokens: { color: '#595959', textLine: 'underline' }
        },
        {
          if: { alternative: true, hover: true, quiet: true },
          tokens: { color: '#595959', textLine: 'underline' }
        },
        {
          if: { hover: true, inverse: true, quiet: true },
          tokens: { color: '#efefef', textLine: 'underline' }
        },
        { if: { style: 'inline' }, tokens: { color: '#000000' } },
        {
          if: { focus: true, style: 'inline' },
          tokens: {
            color: '#000000',
            outerBorderColor: '#000000',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { hover: true, style: 'inline' },
          tokens: { color: '#404040', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'inline' },
          tokens: { color: '#595959', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'inline' },
          tokens: { outerBorderColor: '#595959' }
        },
        { if: { style: 'subtle' }, tokens: { color: '#595959' } },
        {
          if: { focus: true, style: 'subtle' },
          tokens: {
            color: '#000000',
            outerBorderColor: '#000000',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { hover: true, style: 'subtle' },
          tokens: { color: '#404040', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'subtle' },
          tokens: { color: '#595959', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'subtle' },
          tokens: { outerBorderColor: '#595959' }
        },
        { if: { style: 'feature' }, tokens: { color: '#7a3dfc' } },
        {
          if: { focus: true, style: 'feature' },
          tokens: {
            color: '#7a3dfc',
            outerBorderColor: '#7a3dfc',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { hover: true, style: 'feature' },
          tokens: { color: '#5b2bc2', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'feature' },
          tokens: { color: '#595959', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'feature' },
          tokens: { outerBorderColor: '#595959' }
        },
        { if: { style: 'danger' }, tokens: { color: '#c9370b' } },
        {
          if: { focus: true, style: 'danger' },
          tokens: {
            color: '#c9370b',
            outerBorderColor: '#c9370b',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { hover: true, style: 'danger' },
          tokens: { color: '#c9370b', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'danger' },
          tokens: { color: '#595959', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'danger' },
          tokens: { outerBorderColor: '#595959' }
        },
        { if: { style: 'inverse' }, tokens: { color: '#ffffff' } },
        {
          if: { focus: true, style: 'inverse' },
          tokens: {
            color: '#ffffff',
            outerBorderColor: '#ffffff',
            outerBorderOutline: 'none'
          }
        },
        {
          if: { hover: true, style: 'inverse' },
          tokens: { color: '#efefef', textLine: 'none' }
        },
        {
          if: { pressed: true, style: 'inverse' },
          tokens: { color: '#666666', textLine: 'none' }
        },
        {
          if: { focus: true, pressed: true, style: 'inverse' },
          tokens: { outerBorderColor: '#666666' }
        },
        {
          if: { quiet: true, style: 'inline' },
          tokens: { color: '#000000', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'inline' },
          tokens: {
            color: '#000000',
            outerBorderColor: '#000000',
            outerBorderOutline: 'none',
            textLine: 'none'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'inline' },
          tokens: { color: '#404040', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'inline' },
          tokens: { color: '#595959' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'inline' },
          tokens: { outerBorderColor: '#595959' }
        },
        {
          if: { quiet: true, style: 'subtle' },
          tokens: { color: '#595959', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'subtle' },
          tokens: {
            color: '#000000',
            outerBorderColor: '#000000',
            outerBorderOutline: 'none',
            textLine: 'none'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'subtle' },
          tokens: { color: '#404040', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'subtle' },
          tokens: { color: '#595959' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'subtle' },
          tokens: { outerBorderColor: '#595959' }
        },
        {
          if: { quiet: true, style: 'feature' },
          tokens: { color: '#7a3dfc', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'feature' },
          tokens: {
            color: '#7a3dfc',
            outerBorderColor: '#7a3dfc',
            outerBorderOutline: 'none',
            textLine: 'none'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'feature' },
          tokens: { color: '#5b2bc2', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'feature' },
          tokens: { color: '#595959' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'feature' },
          tokens: { outerBorderColor: '#595959' }
        },
        {
          if: { quiet: true, style: 'danger' },
          tokens: { color: '#c9370b', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'danger' },
          tokens: {
            color: '#c9370b',
            outerBorderColor: '#c9370b',
            outerBorderOutline: 'none',
            textLine: 'none'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'danger' },
          tokens: { color: '#c9370b', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'danger' },
          tokens: { color: '#595959' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'danger' },
          tokens: { outerBorderColor: '#595959' }
        },
        {
          if: { quiet: true, style: 'inverse' },
          tokens: { color: '#ffffff', textLine: 'none' }
        },
        {
          if: { focus: true, quiet: true, style: 'inverse' },
          tokens: {
            color: '#ffffff',
            outerBorderColor: '#ffffff',
            outerBorderOutline: 'none',
            textLine: 'none'
          }
        },
        {
          if: { hover: true, quiet: true, style: 'inverse' },
          tokens: { color: '#efefef', textLine: 'underline' }
        },
        {
          if: { pressed: true, quiet: true, style: 'inverse' },
          tokens: { color: '#666666' }
        },
        {
          if: { focus: true, pressed: true, quiet: true, style: 'inverse' },
          tokens: { outerBorderColor: '#666666' }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        blockFontName: 'StagSans',
        blockFontSize: 16,
        blockFontWeight: '600',
        blockLineHeight: 1.5,
        borderRadius: 4,
        color: '#000000',
        icon: null,
        iconSize: 16,
        iconSpace: 1,
        iconTranslateX: 0,
        iconTranslateY: 0,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderOutline: 'none',
        outerBorderWidth: 2,
        textLine: 'underline',
        textLineStyle: 'solid'
      }
    },
    List: {
      appearances: {
        compact: {
          description: 'Reduces line height on some body text styles. For data-rich content, not for flow content',
          type: 'variant',
          values: [ true ]
        },
        size: {
          description: 'Text sizes for block links; similar but not always identical to Typography sizes.',
          type: 'variant',
          values: [ 'large', 'small' ]
        }
      },
      rules: [
        {
          if: { size: 'large' },
          tokens: {
            iconMarginTop: 4,
            itemFontSize: 20,
            itemIconSize: 20,
            itemLineHeight: 1.4
          }
        },
        {
          if: { size: 'small' },
          tokens: {
            iconMarginTop: 0,
            itemFontSize: 14,
            itemIconSize: 20,
            itemLineHeight: 1.42857142857
          }
        },
        {
          if: { compact: true },
          tokens: { iconMarginTop: 1, itemLineHeight: 1.25 }
        },
        {
          if: { compact: true, size: 'small' },
          tokens: { itemLineHeight: 1.14285714286 }
        },
        {
          if: { compact: true, size: 'large' },
          tokens: { itemLineHeight: 1.3 }
        }
      ],
      tokens: {
        bulletIcon: PaletteIconBullet,
        dividerColor: '#c9c8c8',
        dividerSize: 1,
        iconMarginTop: 2,
        interItemMargin: 8,
        interItemMarginWithDivider: 16,
        itemBulletColor: '#000000',
        itemBulletContainerAlign: 'center',
        itemBulletContainerHeight: 20,
        itemBulletContainerWidth: 24,
        itemFontName: 'StagSans',
        itemFontSize: 16,
        itemFontWeight: '400',
        itemIconColor: '#000000',
        itemIconSize: 20,
        itemLineHeight: 1.5,
        itemTextColor: '#000000',
        listGutter: 8
      }
    },
    Listbox: {
      appearances: {
        current: {
          description: 'When the current item is selected',
          type: 'state',
          values: [ true, false ]
        },
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        isChild: {
          description: 'when the item is child of another child',
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { focus: false, hover: true, pressed: false },
          tokens: {
            groupBackgroundColor: '#efefef',
            groupBorderColor: 'rgba(0, 0, 0, 0)',
            itemBackgroundColor: '#efefef'
          }
        },
        {
          if: { focus: true, pressed: false },
          tokens: {
            groupBorderColor: '#7a3dfc',
            groupColor: '#7a3dfc',
            itemBorderBottomColor: '#7a3dfc',
            itemBorderLeftColor: '#7a3dfc',
            itemBorderRightColor: '#7a3dfc',
            itemBorderTopColor: '#7a3dfc'
          }
        },
        {
          if: { current: true },
          tokens: {
            groupBackgroundColor: '#000000',
            groupBorderColor: '#000000',
            groupColor: '#ffffff',
            itemBackgroundColor: '#000000',
            itemColor: '#ffffff'
          }
        },
        {
          if: { current: true, pressed: true },
          tokens: { itemBackgroundColor: '#b5b4b4', itemColor: '#595959' }
        },
        {
          if: { isChild: true },
          tokens: {
            itemBorderBottomWidth: 1,
            itemBorderLeftColor: '#000000',
            itemBorderLeftWidth: 4,
            itemBorderTopWidth: 1
          }
        },
        {
          if: { isChild: true, pressed: true },
          tokens: {
            itemBorderBottomWidth: 1,
            itemBorderLeftColor: '#595959',
            itemBorderTopWidth: 1,
            itemColor: '#595959'
          }
        },
        {
          if: { expanded: true },
          tokens: {
            groupBackgroundColor: 'rgba(0, 0, 0, 0)',
            groupBorderColor: 'rgba(0, 0, 0, 0)',
            groupColor: '#ffffff',
            groupIcon: PaletteIconChevronUp,
            itemColor: '#595959'
          }
        },
        {
          if: { current: true, isChild: true },
          tokens: {
            itemBackgroundColor: '#000000',
            itemBorderLeftColor: '#000000',
            itemColor: '#ffffff'
          }
        },
        {
          if: { current: true, focus: false, hover: true },
          tokens: {
            itemBackgroundColor: '#efefef',
            itemBorderLeftColor: '#efefef',
            itemColor: '#666666'
          }
        },
        {
          if: { current: true, focus: true, hover: true },
          tokens: {
            itemBackgroundColor: '#ffffff',
            itemBorderLeftColor: '#7a3dfc'
          }
        },
        {
          if: { focus: true, isChild: true },
          tokens: {
            itemBackgroundColor: '#ffffff',
            itemBorderBottomColor: '#7a3dfc',
            itemBorderBottomWidth: 1,
            itemBorderLeftColor: '#7a3dfc',
            itemBorderRightColor: '#7a3dfc',
            itemBorderRightWidth: 1,
            itemBorderTopColor: '#7a3dfc',
            itemBorderTopWidth: 1,
            itemColor: '#666666'
          }
        },
        {
          if: { hover: true, isChild: true },
          tokens: {
            itemBackgroundColor: '#efefef',
            itemBorderBottomWidth: 1,
            itemBorderLeftColor: '#666666',
            itemBorderRightWidth: 1,
            itemBorderTopWidth: 1,
            itemColor: '#666666'
          }
        },
        {
          if: { current: true, expanded: true, focus: true },
          tokens: {
            groupBackgroundColor: '#000000',
            groupBorderColor: '#7a3dfc',
            itemBorderLeftColor: '#7a3dfc',
            itemColor: '#666666'
          }
        },
        {
          if: { current: true, expanded: true, hover: true },
          tokens: {
            groupBackgroundColor: '#efefef',
            groupColor: '#666666',
            itemBackgroundColor: '#efefef',
            itemColor: '#666666'
          }
        },
        {
          if: { focus: true },
          tokens: {
            groupBackgroundColor: '#ffffff',
            groupBorderColor: '#7a3dfc',
            groupColor: '#666666',
            itemBackgroundColor: '#ffffff',
            itemBorderBottomColor: '#7a3dfc',
            itemBorderLeftColor: '#7a3dfc',
            itemBorderRightColor: '#7a3dfc',
            itemBorderTopColor: '#7a3dfc',
            itemColor: '#666666'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            groupBackgroundColor: '#404040',
            groupColor: '#666666',
            itemBackgroundColor: '#404040',
            itemBorderLeftColor: '#404040',
            itemColor: '#666666'
          }
        }
      ],
      tokens: {
        groupBackgroundColor: 'rgba(0, 0, 0, 0)',
        groupBorderColor: 'rgba(0, 0, 0, 0)',
        groupBorderRadius: 0,
        groupBorderWidth: 1,
        groupColor: '#666666',
        groupFontName: 'StagSans',
        groupFontSize: 16,
        groupFontWeight: '400',
        groupHeight: 32,
        groupIcon: PaletteIconChevronDown,
        groupPaddingBottom: 12,
        groupPaddingLeft: 16,
        groupPaddingRight: 16,
        groupPaddingTop: 12,
        itemBackgroundColor: 'rgba(0, 0, 0, 0)',
        itemBorderBottomColor: 'rgba(0, 0, 0, 0)',
        itemBorderBottomWidth: 1,
        itemBorderLeftColor: 'rgba(0, 0, 0, 0)',
        itemBorderLeftWidth: 1,
        itemBorderRadius: 0,
        itemBorderRightColor: 'rgba(0, 0, 0, 0)',
        itemBorderRightWidth: 1,
        itemBorderTopColor: 'rgba(0, 0, 0, 0)',
        itemBorderTopWidth: 1,
        itemBorderWidth: 0,
        itemColor: '#666666',
        itemDisplay: false,
        itemFontName: 'StagSans',
        itemFontSize: 16,
        itemFontWeight: '400',
        itemHeight: 32,
        itemOutline: 0,
        itemPaddingBottom: 8,
        itemPaddingLeft: 16,
        itemPaddingRight: 16,
        itemPaddingTop: 8,
        itemTextDecoration: 'none',
        lineHeight: 1.5,
        minHeight: '100%',
        minWidth: '100%',
        shadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.2)',
          inset: false,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        }
      }
    },
    Modal: {
      appearances: {
        maxWidth: {
          description: 'Whether a modal should expand responsively to the maximum of 8 layout columns width',
          type: 'state',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        },
        width: {
          description: 'The width of the modal',
          type: 'state',
          values: [ 's', 'm', 'l', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: {
            direction: 'column',
            height: '100%',
            marginLeft: 24,
            marginRight: 24,
            paddingBottom: 24,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 24
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            direction: 'row',
            maxWidth: 576,
            paddingBottom: 32,
            paddingLeft: 32,
            paddingRight: 32,
            paddingTop: 32
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ], width: 's' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 320
          }
        },
        {
          if: { viewport: [ 'md', 'lg', 'xl' ], width: 'm' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 480
          }
        },
        {
          if: { viewport: [ 'lg', 'xl' ], width: 'l' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 630
          }
        },
        {
          if: { viewport: 'xl', width: 'xl' },
          tokens: {
            containerPaddingBottom: 32,
            containerPaddingTop: 32,
            maxWidth: 768
          }
        },
        {
          if: { maxWidth: true, viewport: 'md' },
          tokens: {
            containerPaddingLeft: 16,
            containerPaddingRight: 16,
            maxWidth: 480
          }
        },
        {
          if: { maxWidth: true, viewport: 'lg' },
          tokens: {
            containerPaddingLeft: 16,
            containerPaddingRight: 16,
            maxWidth: 630
          }
        },
        {
          if: { maxWidth: true, viewport: 'xl' },
          tokens: {
            containerPaddingLeft: 16,
            containerPaddingRight: 16,
            maxWidth: 768
          }
        }
      ],
      tokens: {
        backdropColor: '#000000',
        backdropOpacity: 0.5,
        backgroundColor: '#ffffff',
        borderColor: '#ffffff',
        borderRadius: 4,
        borderWidth: 0,
        cancelButtonColor: '#000000',
        closeIcon: PaletteIconTimes,
        closeIconColor: '#000000',
        closeIconSize: 24,
        closePadding: 4,
        containerPaddingBottom: 0,
        containerPaddingLeft: 0,
        containerPaddingRight: 0,
        containerPaddingTop: 0,
        contentPaddingBottom: 0,
        contentPaddingTop: 0,
        direction: 'row',
        footerTopWidth: 0,
        gap: 16,
        headingBorderBottomWidth: 0,
        headingColor: '#000000',
        headingPaddingRight: 24,
        headingPaddingTop: 8,
        height: null,
        marginLeft: 32,
        marginRight: 32,
        maxWidth: '100%',
        paddingBottom: 24,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 24,
        shadow: {
          blur: 8,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: false,
          offsetX: 0,
          offsetY: 4,
          spread: 0
        },
        subHeadingMarginTop: 8
      }
    },
    MultiSelectFilter: {
      appearances: {
        maxHeight: {
          description: 'Whether MultiselectFilter modal should expand responsively to content or a set maximu height',
          type: 'state',
          values: [ true ]
        },
        maxWidth: {
          description: 'Whether MultiselectFilter modal should expand to content or a set maximuh width',
          type: 'state',
          values: [ true ]
        },
        selected: { type: 'state', values: [ true ] },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs' ] },
          tokens: {
            buttonDirection: 'column',
            minHeight: '100%',
            minWidth: '100%'
          }
        },
        {
          if: { maxHeight: true, viewport: [ 'sm', 'md', 'lg', 'xl' ] },
          tokens: { maxHeightSize: 480 }
        },
        {
          if: { maxWidth: true, viewport: [ 'sm', 'md', 'lg', 'xl' ] },
          tokens: { maxWidthSize: 544 }
        },
        {
          if: { selected: true },
          tokens: {
            buttonIconBackgroundColor: 'rgba(0, 0, 0, 0)',
            labelColor: '#000000'
          }
        }
      ],
      tokens: {
        buttonBackgroundColor: '#ffffff',
        buttonBackgroundColorSelected: '#ffffff',
        buttonBorderColor: '#000000',
        buttonDirection: 'row',
        buttonIconBackgroundColor: 'rgba(0, 0, 0, 0)',
        buttonIconPadding: 4,
        buttonIconSize: 20,
        containerBorderColor: '#c9c8c8',
        contentMarginBottom: 32,
        contentMarginLeft: 16,
        contentMarginRight: 16,
        contentMarginTop: 24,
        contentPaddingLeft: 16,
        contentPaddingRight: 16,
        dividerColor: '#c9c8c8',
        headerFontColor: '#000000',
        headerFontName: 'StagSans',
        headerFontSize: 14,
        headerFontWeight: '700',
        headerLineHeight: 1.33333333333,
        iconColor: '#000000',
        iconColorSelected: '#000000',
        labelColor: '#000000',
        labelFontName: 'StagSans',
        labelFontSize: 14,
        labelFontWeight: '600',
        labelLineHeight: 1.5,
        labelPaddingBottom: 8,
        labelPaddingLeft: 24,
        labelPaddingRight: 16,
        labelPaddingTop: 8,
        maxHeightSize: 480,
        maxWidthSize: 0,
        minHeight: 0,
        minWidth: 320,
        subHeaderFontName: 'StagSans',
        subHeaderFontSize: 16,
        subHeaderFontWeight: '400',
        subHeaderLineHeight: 1.5
      }
    },
    NavigationBar: {
      appearances: {
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { selected: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            borderColor: '#c9c8c8',
            color: '#000000',
            fontName: 'StagSans',
            fontWeight: '600',
            outerBorderColor: '#c9c8c8'
          }
        },
        {
          if: { focus: true },
          tokens: {
            borderColor: '#000000',
            borderWidth: 0,
            outerBorderColor: '#000000',
            outerBorderWidth: 3
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: {
            backgroundColor: '#595959',
            borderColor: '#595959',
            borderWidth: 1,
            color: '#c9c8c8'
          }
        },
        {
          if: { hover: true },
          tokens: {
            backgroundColor: '#404040',
            borderColor: '#404040',
            color: '#ffffff',
            outerBorderColor: '#404040'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#595959',
            borderColor: '#595959',
            borderWidth: 1,
            color: '#c9c8c8',
            outerBorderColor: '#595959'
          }
        },
        {
          if: { viewport: [ 'xs', 'sm', 'md' ] },
          tokens: { textAlign: 'space-between', width: 288 }
        },
        {
          if: { viewport: [ 'lg', 'xl' ] },
          tokens: { borderRadius: 32 }
        },
        {
          if: { hover: true, selected: true },
          tokens: {
            backgroundColor: '#404040',
            borderColor: '#404040',
            color: '#ffffff',
            fontName: 'StagSans',
            fontWeight: '600'
          }
        },
        {
          if: { pressed: true, selected: true },
          tokens: {
            backgroundColor: '#595959',
            borderColor: '#595959',
            color: '#c9c8c8',
            fontName: 'StagSans',
            fontWeight: '600',
            outerBorderColor: '#595959'
          }
        },
        {
          if: { expanded: true },
          tokens: { icoMenu: PaletteIconChevronUp }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#ffffff',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 4,
        borderWidth: 0,
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 14,
        fontWeight: '600',
        icoMenu: PaletteIconChevronDown,
        lineHeight: 1.45,
        minWidth: 0,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: '#c9c8c8',
        outerBorderGap: 0,
        outerBorderWidth: 1,
        paddingBottom: 6,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 6,
        shadow: null,
        textAlign: 'center',
        width: 0
      }
    },
    Notification: {
      appearances: {
        style: {
          type: 'variant',
          values: [ 'system', 'success', 'warning', 'error', 'subtle' ]
        },
        system: { type: 'state', values: [ true ] },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success', 'warning', 'feature' ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { system: true },
          tokens: {
            borderLeftWidth: 0,
            borderRadius: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            iconGap: 8
          }
        },
        {
          if: { style: 'system' },
          tokens: {
            borderLeftWidth: 0,
            borderRadius: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            iconGap: 8
          }
        },
        {
          if: { style: 'subtle' },
          tokens: {
            borderBottomWidth: 0,
            borderLeftWidth: 0,
            borderRadius: 6,
            borderRightWidth: 0,
            borderTopWidth: 0,
            iconGap: 8
          }
        },
        {
          if: { style: 'success' },
          tokens: {
            backgroundColor: '#c5f2cc',
            borderColor: '#1c7b2b',
            color: '#000000',
            icon: PaletteIconCheckCircleFilled,
            iconColor: '#1c7b2b'
          }
        },
        {
          if: { validation: 'success' },
          tokens: {
            backgroundColor: '#c5f2cc',
            borderColor: '#1c7b2b',
            color: '#000000',
            icon: PaletteIconCheckCircleFilled,
            iconColor: '#1c7b2b'
          }
        },
        {
          if: { style: 'warning' },
          tokens: {
            backgroundColor: '#fff5d2',
            borderColor: '#f8c100',
            color: '#000000',
            dismissIcon: null,
            icon: PaletteIconExclamationTriangle,
            iconColor: '#c9370b'
          }
        },
        {
          if: { validation: 'warning' },
          tokens: {
            backgroundColor: '#fff5d2',
            borderColor: '#f8c100',
            color: '#000000',
            dismissIcon: null,
            icon: PaletteIconExclamationTriangle,
            iconColor: '#c9370b'
          }
        },
        {
          if: { style: 'error' },
          tokens: {
            backgroundColor: '#fcd3c6',
            borderColor: '#c9370b',
            color: '#000000',
            dismissIcon: null,
            icon: PaletteIconExclamationOctagon,
            iconColor: '#c9370b'
          }
        },
        {
          if: { validation: 'error' },
          tokens: {
            backgroundColor: '#fcd3c6',
            borderColor: '#c9370b',
            color: '#000000',
            dismissIcon: null,
            icon: PaletteIconExclamationOctagon,
            iconColor: '#c9370b'
          }
        },
        {
          if: { validation: 'feature' },
          tokens: {
            backgroundColor: '#e0d8fc',
            borderColor: '#7a3dfc',
            color: '#000000',
            dismissIcon: null,
            icon: PaletteIconTagFilled,
            iconColor: '#7a3dfc'
          }
        }
      ],
      tokens: {
        backgroundColor: '#efefef',
        borderBottomWidth: 1,
        borderColor: '#000000',
        borderLeftWidth: 1,
        borderRadius: 6,
        borderRightWidth: 1,
        borderTopWidth: 1,
        color: '#000000',
        containerPaddingLeft: 0,
        containerPaddingRight: 0,
        dismissButtonGap: 24,
        dismissIcon: PaletteIconClose,
        dismissIconColor: '#000000',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '400',
        icon: null,
        iconColor: null,
        iconGap: 8,
        iconSize: 24,
        justifyContent: 'flex-start',
        lineHeight: 1.5,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12
      }
    },
    OrderedList: {
      appearances: {
        compact: {
          description: 'When true it will reduce the line height of the list item.',
          type: 'variant',
          values: [ true ]
        },
        size: {
          description: 'Indicates list item text size.',
          type: 'variant',
          values: [ 'large', 'medium', 'small' ]
        }
      },
      rules: [
        {
          if: { size: 'large' },
          tokens: { itemFontSize: 20, itemLineHeight: 1.4 }
        },
        {
          if: { size: 'small' },
          tokens: { itemFontSize: 14, itemLineHeight: 1.42857142857 }
        },
        { if: { compact: true }, tokens: { itemLineHeight: 1.25 } },
        {
          if: { compact: true, size: 'small' },
          tokens: { itemLineHeight: 1.14285714286 }
        },
        {
          if: { compact: true, size: 'large' },
          tokens: { itemLineHeight: 1.2 }
        }
      ],
      tokens: {
        headerFontName: 'StagSans',
        headerFontWeight: '600',
        interItemMargin: 8,
        itemBulletContainerWidth: 20,
        itemBulletHeight: 4,
        itemBulletTextAlign: 'right',
        itemBulletWidth: 4,
        itemColor: null,
        itemFontName: 'StagSans',
        itemFontSize: 16,
        itemFontWeight: '400',
        itemLineHeight: 1.5,
        itemMarginTop: 0,
        itemPaddingTop: 0,
        itemTextColor: '#000000',
        listGutter: 8
      }
    },
    Pagination: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: { gap: 4, truncateAbove: 6 }
        }
      ],
      tokens: {
        borderBottomWidth: 0,
        borderColor: '#016b6a',
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        color: '#666666',
        ellipsisBorderBottomWidth: 0,
        ellipsisBorderLeftWidth: 0,
        ellipsisBorderRightWidth: 0,
        ellipsisBorderTopWidth: 0,
        ellipsisHeight: null,
        ellipsisPadding: 0,
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '400',
        gap: 2,
        lineHeight: 1.5,
        truncateAbove: 4
      }
    },
    PaginationPageButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { borderColor: '#000000', textLine: 'none' }
        },
        { if: { focus: true }, tokens: { borderColor: '#000000' } },
        {
          if: { selected: true },
          tokens: {
            backgroundColor: '#7a3dfc',
            color: '#ffffff',
            textLine: 'none'
          }
        },
        {
          if: { hover: true, selected: true },
          tokens: { borderColor: '#7a3dfc' }
        },
        {
          if: { focus: true, selected: true },
          tokens: { borderColor: '#7a3dfc' }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#000000',
            borderColor: '#000000',
            color: '#666666'
          }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderBottomWidth: 1,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderLeftWidth: 1,
        borderRadius: 32,
        borderRightWidth: 1,
        borderTopWidth: 1,
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        height: 32,
        lineHeight: 1,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 4,
        outerBorderWidth: 4,
        paddingBottom: 8,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 8,
        textAlign: 'center',
        textLine: 'underline',
        width: 32
      }
    },
    PaginationSideButton: {
      appearances: {
        compact: {
          description: 'Determines if the "Next" and "Previous" labels should be omitted',
          type: 'state',
          values: [ true ]
        },
        direction: {
          description: "Determines which way does the button navigate in Pagination's context",
          type: 'state',
          values: [ 'previous', 'next' ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        { if: { compact: true }, tokens: { displayLabel: false } },
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: {
            borderRadius: 32,
            displayLabel: false,
            paddingBottom: 8,
            paddingLeft: 8,
            paddingRight: 8,
            paddingTop: 8
          }
        },
        {
          if: { hover: true },
          tokens: {
            borderBottomWidth: 1,
            borderColor: '#000000',
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderTopWidth: 1,
            iconDisplace: 4,
            textLine: 'none'
          }
        },
        {
          if: { focus: true },
          tokens: {
            borderBottomWidth: 1,
            borderColor: '#000000',
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderTopWidth: 1
          }
        },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#000000', color: '#666666' }
        },
        {
          if: { direction: 'previous' },
          tokens: { icon: PaletteIconChevronLeft }
        },
        {
          if: { direction: 'next' },
          tokens: { icon: PaletteIconChevronRight }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderBottomWidth: 0,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderLeftWidth: 0,
        borderRadius: 4,
        borderRightWidth: 0,
        borderTopWidth: 0,
        color: '#000000',
        displayLabel: true,
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        height: null,
        icon: null,
        iconDisplace: 0,
        iconSize: 16,
        lineHeight: 1.5,
        outerBorderColor: 'transparent',
        outerBorderWidth: 1,
        paddingBottom: 12,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 12,
        textAlign: 'center',
        textLine: 'none',
        width: null
      }
    },
    PreviewCard: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { borderColor: '#efefef', borderWidth: 3 }
        },
        {
          if: { focus: true },
          tokens: {
            outerBorderColor: '#000000',
            outerBorderGap: 2,
            outerBorderWidth: 2
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#efefef',
            borderColor: 'transparent',
            outerBorderColor: '#000000'
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#efefef',
        borderRadius: 8,
        borderWidth: 1,
        flex: 1,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        separatorColor: '#000000'
      }
    },
    PriceLockup: {
      appearances: {
        price: { type: 'variant', values: [ 'default', 'baseline' ] },
        size: {
          type: 'variant',
          values: [ 'micro', 'small', 'medium', 'large' ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { size: 'micro' },
          tokens: {
            amountFontSize: 24,
            bottomTextFontSize: 12,
            bottomTextLineHeight: 1.2,
            centsFontSize: 16,
            centsLineHeight: 1,
            centsPaddingTop: 2,
            currencySymbolFontSize: 16,
            currencySymbolLineHeight: 1,
            currencySymbolPaddingTop: 2,
            footnoteLinkFontSize: 12,
            footnoteLinkLineHeight: 1,
            footnoteMarginTop: 0,
            rateFontSize: 12,
            rateLineHeight: 2,
            strikeThroughHeight: 2,
            strikeThroughPosition: 18,
            topTextFontSize: 12,
            topTextLineHeight: 1.2
          }
        },
        {
          if: { size: 'small' },
          tokens: {
            amountFontSize: 36,
            centsFontSize: 20,
            centsLineHeight: 1.25,
            currencySymbolFontSize: 20,
            footnoteLinkLineHeight: 1.14285714286,
            rateFontSize: 16,
            rateLineHeight: 1.5,
            strikeThroughHeight: 2,
            strikeThroughPosition: 18,
            topTextFontSize: 14,
            topTextLineHeight: 1.14285714286
          }
        },
        {
          if: { size: 'large' },
          tokens: {
            amountFontSize: 54,
            centsFontName: 'StagSans',
            centsFontSize: 24,
            centsFontWeight: '600',
            currencySymbolFontSize: 32,
            footnoteLinkLineHeight: 1.2,
            rateFontName: 'StagSans',
            rateFontSize: 16,
            rateFontWeight: '600',
            rateLineHeight: 1.5,
            strikeThroughPosition: 27,
            topTextFontSize: 20,
            topTextLineHeight: 1.2
          }
        },
        {
          if: { size: 'large', viewport: [ 'lg', 'xl' ] },
          tokens: {
            centsFontName: 'StagSans',
            centsFontSize: 32,
            centsFontWeight: '700'
          }
        },
        {
          if: { price: 'baseline' },
          tokens: {
            centsFontName: 'StagSans',
            centsFontSize: 44,
            centsFontWeight: '700',
            centsLineHeight: 1,
            rateLineHeight: 1.72
          }
        },
        {
          if: { price: 'baseline', size: 'micro' },
          tokens: {
            centsFontName: 'StagSans',
            centsFontSize: 24,
            centsFontWeight: '700',
            centsLineHeight: 1,
            centsPaddingTop: 0,
            rateLineHeight: 2.13
          }
        },
        {
          if: { price: 'baseline', size: 'small' },
          tokens: {
            centsFontName: 'StagSans',
            centsFontSize: 36,
            centsFontWeight: '700',
            centsLineHeight: 1,
            rateLineHeight: 1.72
          }
        },
        {
          if: { price: 'baseline', size: 'large' },
          tokens: {
            centsFontName: 'StagSans',
            centsFontSize: 54,
            centsFontWeight: '700',
            centsLineHeight: 1,
            rateLineHeight: 1.72
          }
        }
      ],
      tokens: {
        alignItemsText: 'flex-start',
        amountFontName: 'StagSans',
        amountFontSize: 44,
        amountFontWeight: '700',
        amountLetterSpacing: 0,
        amountLineHeight: 1,
        bottomLinksMarginLeft: 4,
        bottomTextFontSize: 14,
        bottomTextLineHeight: 1.14285714286,
        bottomTextMarginTop: 0,
        centsFontName: 'StagSans',
        centsFontSize: 24,
        centsFontWeight: '700',
        centsLineHeight: 1,
        centsPaddingTop: 0,
        currencySymbolFontName: 'StagSans',
        currencySymbolFontSize: 24,
        currencySymbolFontWeight: '700',
        currencySymbolLineHeight: 1,
        currencySymbolPaddingTop: 0,
        dividerColor: null,
        fontColor: '#000000',
        fontName: 'StagSans',
        fontWeight: '700',
        footnoteGap: 4,
        footnoteLinkColor: '#000000',
        footnoteLinkFontName: 'StagSans',
        footnoteLinkFontSize: 14,
        footnoteLinkFontWeight: '600',
        footnoteLinkLineHeight: 1.25,
        footnoteMarginTop: 4,
        priceMarginBottom: 0,
        rateFontName: 'StagSans',
        rateFontSize: 16,
        rateFontWeight: '700',
        rateLineHeight: 1.5,
        strikeThroughColor: '#000000',
        strikeThroughHeight: 3,
        strikeThroughPosition: 21,
        topTextFontName: 'StagSans',
        topTextFontSize: 16,
        topTextFontWeight: '700',
        topTextLineHeight: 1.25,
        topTextMarginBottom: 4
      }
    },
    ProductCard: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm', 'md' ] },
          tokens: { borderWidth: 0, paddingHorizontal: 24, paddingVertical: 0 }
        }
      ],
      tokens: {
        borderColor: '#efefef',
        borderRadius: 6,
        borderStyle: 'solid',
        borderWidth: 1,
        paddingHorizontal: 24,
        paddingVertical: 24,
        selectedButtonIcon: PaletteIconCheck
      }
    },
    Progress: {
      appearances: {
        size: { type: 'variant', values: [ 'mini' ] },
        style: {
          description: 'Configure `style` variant for `Progress`',
          type: 'variant',
          values: [ 'inverse' ]
        }
      },
      rules: [
        { if: { size: 'mini' }, tokens: { height: 8 } },
        {
          if: { style: 'inverse' },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderColor: 'rgba(255, 255, 255, 0.4)',
            shadow: {
              blur: 2,
              color: 'rgba(0, 0, 0, 0.1)',
              inset: true,
              offsetX: 0,
              offsetY: 2,
              spread: 0
            }
          }
        }
      ],
      tokens: {
        backgroundColor: '#fafafa',
        borderColor: '#666666',
        borderRadius: 12,
        borderWidth: 1,
        height: 16,
        shadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: true,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        }
      }
    },
    ProgressBar: {
      appearances: {
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        negative: { type: 'variant', values: [ true ] },
        style: {
          description: 'Configure `style` variant for `ProgressBar`',
          type: 'variant',
          values: [ 'subtle', 'inverse', 'inactive', 'negative' ]
        }
      },
      rules: [
        {
          if: { inactive: true },
          tokens: { backgroundColor: '#c9c8c8', outlineColor: '#595959' }
        },
        {
          if: { negative: true },
          tokens: { backgroundColor: '#c9370b', outlineColor: '#595959' }
        },
        {
          if: { style: 'subtle' },
          tokens: {
            backgroundColor: '#666666',
            gradient: null,
            outlineColor: '#666666'
          }
        },
        {
          if: { style: 'inverse' },
          tokens: {
            backgroundColor: '#ffffff',
            gradient: null,
            outlineColor: '#ffffff'
          }
        },
        {
          if: { style: 'inactive' },
          tokens: { backgroundColor: '#c9c8c8', outlineColor: '#595959' }
        },
        {
          if: { style: 'negative' },
          tokens: { backgroundColor: '#c9370b', outlineColor: '#595959' }
        }
      ],
      tokens: {
        backgroundColor: '#000000',
        borderRadius: 12,
        gradient: null,
        outlineColor: '#595959',
        outlineWidth: 1,
        shadow: null
      }
    },
    QuantitySelector: {
      appearances: {
        alternative: { type: 'variant', values: [ true ] },
        disabled: { type: 'variant', values: [ true ] },
        focus: { type: 'variant', values: [ true ] },
        hover: { type: 'variant', values: [ true ] },
        pressed: { type: 'variant', values: [ true ] }
      },
      rules: [
        {
          if: { alternative: true },
          tokens: { paddingBottom: 8, paddingTop: 8 }
        },
        {
          if: { hover: true },
          tokens: { inputBackgroundColor: '#efefef' }
        },
        {
          if: { disabled: true },
          tokens: { inputBackgroundColor: '#efefef', textColor: '#c9c8c8' }
        },
        { if: { focus: true }, tokens: { inputBorderWidth: 3 } }
      ],
      tokens: {
        fontSize: 16,
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#666666',
        inputBorderWidth: 1,
        inputWidth: 64,
        lineHeight: 1.5,
        padding: 12,
        paddingBottom: 12,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 12,
        textColor: '#000000'
      }
    },
    QuantitySelectorSideButton: {
      appearances: {
        alternative: { type: 'variant', values: [ true ] },
        decrease: { type: 'variant', values: [ true ] },
        disabled: { type: 'variant', values: [ true ] },
        focus: { type: 'variant', values: [ true ] },
        hover: { type: 'variant', values: [ true ] },
        increase: { type: 'variant', values: [ true ] },
        pressed: { type: 'variant', values: [ true ] }
      },
      rules: [
        { if: { hover: true }, tokens: { backgroundColor: '#efefef' } },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#c9c8c8', borderWidth: 3 }
        },
        {
          if: { decrease: true },
          tokens: {
            borderBottomLeftRadius: 4,
            borderRightWidth: 0,
            borderTopLeftRadius: 4,
            icon: PaletteIconSubtract
          }
        },
        {
          if: { increase: true },
          tokens: {
            borderBottomRightRadius: 4,
            borderLeftWidth: 0,
            borderTopRightRadius: 4,
            icon: PaletteIconAdd
          }
        },
        {
          if: { focus: true, increase: true },
          tokens: {
            borderBottomWidth: 3,
            borderLeftWidth: 2,
            borderRightWidth: 3,
            borderTopWidth: 3
          }
        },
        {
          if: { decrease: true, focus: true },
          tokens: {
            borderBottomWidth: 3,
            borderLeftWidth: 3,
            borderRightWidth: 2,
            borderTopWidth: 3
          }
        },
        {
          if: { disabled: true },
          tokens: { backgroundColor: '#efefef', iconColor: '#c9c8c8' }
        },
        {
          if: { alternative: true },
          tokens: { paddingBottom: 12, paddingTop: 12 }
        },
        {
          if: { alternative: true, increase: true },
          tokens: { borderBottomRightRadius: 24, borderTopRightRadius: 24 }
        },
        {
          if: { alternative: true, decrease: true },
          tokens: { borderBottomLeftRadius: 24, borderTopLeftRadius: 24 }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderBottomWidth: 1,
        borderColor: '#666666',
        borderLeftWidth: 1,
        borderRadius: 0,
        borderRightWidth: 1,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderTopWidth: 1,
        borderWidth: 1,
        icon: null,
        iconColor: '#000000',
        iconSize: 16,
        padding: 16,
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 16
      }
    },
    QuickLinks: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: { card: false, dividers: true, list: false }
        }
      ],
      tokens: {
        card: true,
        dividers: true,
        list: true,
        stackGap: 2,
        stackJustify: 'center',
        stackSpace: 4
      }
    },
    QuickLinksButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { borderWidth: 3 } },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            borderColor: '#000000',
            iconColor: '#666666'
          }
        },
        {
          if: { focus: true },
          tokens: { outerBorderColor: '#000000' }
        },
        {
          if: { focus: true, pressed: true },
          tokens: { borderWidth: 1, outerBorderColor: '#000000' }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#ffffff',
        borderColor: '#c9c8c8',
        borderRadius: 48,
        borderWidth: 1,
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        icon: null,
        iconColor: '#000000',
        iconSize: 24,
        iconSpace: 2,
        lineHeight: 1.5,
        minWidth: 0,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: '#ffffff',
        outerBorderGap: 2,
        outerBorderWidth: 2,
        paddingBottom: 12,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 12,
        shadow: null,
        textAlign: 'center',
        width: null
      }
    },
    QuickLinksCard: {
      appearances: {},
      rules: [],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#c9c8c8',
        borderRadius: 8,
        borderWidth: 1,
        flex: 1,
        minWidth: null,
        paddingBottom: 8,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 8,
        shadow: null
      }
    },
    QuickLinksFeature: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [ { if: { viewport: 'xs' }, tokens: { stackSpace: 4 } } ],
      tokens: { stackGap: 5, stackJustify: 'center', stackSpace: 5 }
    },
    QuickLinksFeatureItem: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: 'xl' },
          tokens: { contentMaxDimension: 184, imageDimension: 168 }
        },
        {
          if: { hover: true },
          tokens: {
            color: '#404040',
            imageDimension: 140,
            textLine: 'underline'
          }
        },
        {
          if: { focus: true },
          tokens: { color: '#000000', outerBorderColor: '#000000' }
        },
        {
          if: { pressed: true },
          tokens: {
            color: '#595959',
            outerBorderColor: '#595959',
            textLine: 'underline'
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: {
            color: '#595959',
            outerBorderColor: '#595959',
            textLine: 'underline'
          }
        },
        {
          if: { hover: true, viewport: 'xl' },
          tokens: { imageDimension: 184 }
        }
      ],
      tokens: {
        color: '#000000',
        contentAlignItems: 'center',
        contentDirection: 'column',
        contentMaxDimension: 168,
        contentSpace: 3,
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        gap: 5,
        imageDimension: 128,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        textAlign: 'center',
        textLine: 'none'
      }
    },
    QuickLinksList: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { backgroundColor: '#efefef' } },
        { if: { focus: true }, tokens: { backgroundColor: '#efefef' } },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#c9c8c8', itemIconColor: '#000000' }
        }
      ],
      tokens: {
        backgroundColor: null,
        dividerColor: '#c9c8c8',
        dividerSize: 1,
        iconMarginTop: 0,
        interItemMargin: null,
        interItemMarginWithDivider: null,
        itemBulletColor: '#7c1366',
        itemBulletContainerAlign: 'center',
        itemBulletContainerWidth: 0,
        itemBulletHeight: 0,
        itemBulletWidth: 0,
        itemFontColor: '#000000',
        itemFontName: 'StagSans',
        itemFontSize: 16,
        itemFontWeight: '600',
        itemIconColor: '#000000',
        itemIconSize: 24,
        itemLineHeight: 1.6,
        itemUnderline: 'none',
        listGutter: 12,
        paddingBottom: 12,
        paddingLeft: 4,
        paddingRight: 4,
        paddingTop: 12
      }
    },
    Radio: {
      appearances: {
        checked: {
          description: 'Corresponds to a selected state for a checkbox or radio',
          type: 'state',
          values: [ true ]
        },
        error: { type: 'state', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { error: true },
          tokens: {
            inputBackgroundColor: '#ffffff',
            inputBorderColor: '#ffffff',
            inputOutlineColor: '#000000',
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            outerBorderGap: 0,
            outerBorderWidth: 0
          }
        },
        {
          if: { focus: true },
          tokens: {
            outerBorderColor: '#000000',
            outerBorderGap: 2,
            outerBorderWidth: 1
          }
        },
        {
          if: { hover: true },
          tokens: { outerBorderColor: '#000000' }
        },
        {
          if: { inactive: true },
          tokens: {
            inputBackgroundColor: '#c9c8c8',
            inputBorderColor: '#c9c8c8',
            inputOutlineColor: '#c9c8c8',
            labelColor: '#666666',
            outerBorderGap: 0
          }
        },
        {
          if: { checked: true, inactive: true },
          tokens: {
            checkedBackgroundColor: '#c9c8c8',
            inputBackgroundColor: '#ffffff',
            inputBorderColor: '#efefef',
            inputBorderWidth: 3,
            inputOutlineColor: '#c9c8c8',
            inputOutlineWidth: 1,
            labelColor: '#666666',
            outerBorderColor: '#c9c8c8'
          }
        }
      ],
      tokens: {
        checkedBackgroundColor: '#7a3dfc',
        checkedSize: 12,
        containerBackgroundColor: 'rgba(0, 0, 0, 0)',
        containerBorderRadius: 0,
        containerOpacity: 1,
        containerPaddingBottom: 0,
        containerPaddingLeft: 0,
        containerPaddingRight: 0,
        containerPaddingTop: 0,
        containerShadow: null,
        descriptionFontName: 'StagSans',
        descriptionFontSize: 14,
        descriptionFontWeight: '400',
        descriptionLineHeight: 1.4,
        descriptionMarginLeft: null,
        icon: null,
        iconBackgroundColor: 'rgba(0, 0, 0, 0)',
        iconColor: 'rgba(0, 0, 0, 0)',
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#000000',
        inputBorderWidth: 1,
        inputOutlineColor: '#000000',
        inputOutlineWidth: 1,
        inputSize: 20,
        labelColor: '#000000',
        labelFontName: 'StagSans',
        labelFontSize: 16,
        labelFontWeight: '400',
        labelLineHeight: 1.5,
        labelMarginLeft: 8,
        outerBorderColor: 'transparent',
        outerBorderGap: 1,
        outerBorderWidth: 1
      }
    },
    RadioCard: {
      appearances: {
        checked: {
          description: 'Corresponds to a selected state for a checkbox or radio',
          type: 'state',
          values: [ true ]
        },
        error: { type: 'state', values: [ true ] },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'lg', 'xl' ] },
          tokens: {
            fontSize: 24,
            lineHeight: 1.3,
            paddingBottom: 24,
            paddingLeft: 16,
            paddingRight: 24,
            paddingTop: 16
          }
        },
        {
          if: { hover: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderColor: '#c9c8c8',
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            outerBorderGap: 0,
            outerBorderWidth: 0,
            radioOuterBorderColor: 'rgba(0, 0, 0, 0)',
            radioOuterBorderGap: 0
          }
        },
        {
          if: { checked: true },
          tokens: {
            borderColor: '#c9c8c8',
            radioCheckedBackgroundColor: '#7a3dfc',
            radioInputBorderColor: '#000000',
            radioInputBorderWidth: 2
          }
        },
        {
          if: { focus: true },
          tokens: {
            borderColor: '#666666',
            outerBorderColor: '#000000',
            outerBorderGap: 2,
            outerBorderWidth: 2,
            radioInputBorderColor: '#000000',
            radioOuterBorderColor: '#000000',
            radioOuterBorderGap: 2,
            radioOuterBorderWidth: 1
          }
        },
        {
          description: 'Pressed state matches hover state plus light grey background',
          if: { pressed: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderColor: '#c9c8c8',
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            outerBorderGap: 0,
            outerBorderWidth: 0,
            radioOuterBorderColor: 'rgba(0, 0, 0, 0)',
            radioOuterBorderGap: 0
          }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#efefef',
            borderColor: 'transparent',
            color: '#666666',
            radioCheckedBackgroundColor: '#c9c8c8',
            radioInputBackgroundColor: '#c9c8c8',
            radioInputBorderColor: '#c9c8c8',
            radioInputSize: 16,
            radioOuterBorderColor: '#c9c8c8',
            radioOuterBorderGap: 2,
            radioOuterBorderWidth: 1
          }
        },
        {
          if: { error: true },
          tokens: {
            borderColor: '#df3d0c',
            color: '#df3d0c',
            radioInputBorderColor: '#df3d0c'
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#c9c8c8',
        borderRadius: 4,
        borderWidth: 1,
        color: '#000000',
        contentAlignItems: 'stretch',
        contentFlexGrow: 0,
        contentFlexShrink: 1,
        contentJustifyContent: 'flex-start',
        contentSpace: 2,
        flex: 1,
        fontName: 'StagSans',
        fontSize: 20,
        fontWeight: '700',
        letterSpacing: 0,
        lineHeight: 1.4,
        minWidth: 288,
        outerBorderColor: 'transparent',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        paddingBottom: 16,
        paddingLeft: 8,
        paddingRight: 16,
        paddingTop: 12,
        radioCheckedBackgroundColor: '#000000',
        radioCheckedSize: 16,
        radioInputBackgroundColor: '#ffffff',
        radioInputBorderColor: '#000000',
        radioInputBorderWidth: 2,
        radioInputOutlineColor: 'rgba(0, 0, 0, 0)',
        radioInputOutlineWidth: 0,
        radioInputSize: 24,
        radioOuterBorderColor: 'transparent',
        radioOuterBorderGap: 0,
        radioOuterBorderWidth: 0,
        radioSpace: 2,
        shadow: null,
        textTransform: 'none'
      }
    },
    RadioCardGroup: {
      appearances: {
        fullWidth: {
          description: 'Makes cards always occupy the full width of the parent, regardless of viewport',
          type: 'variant',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { fullWidth: null, viewport: [ 'md', 'lg', 'xl' ] },
          tokens: { direction: 'row', space: 5 }
        }
      ],
      tokens: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        borderTopLeftRadius: 1,
        borderTopRightRadius: 1,
        direction: 'column',
        fieldSpace: 3,
        outlineOffset: 8,
        outlineWidth: 1,
        showIcon: true,
        space: 3
      }
    },
    RadioGroup: {
      appearances: {},
      rules: [],
      tokens: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        borderTopLeftRadius: 1,
        borderTopRightRadius: 1,
        fieldSpace: 2,
        outlineOffset: 8,
        outlineWidth: 1,
        showIcon: true,
        space: 2
      }
    },
    Ribbon: {
      appearances: {
        purpose: {
          type: 'variant',
          values: [ 'offer', 'default', 'editorial', 'subtle' ]
        },
        wrap: { type: 'variant', values: [ true ] }
      },
      rules: [
        {
          if: { purpose: 'editorial' },
          tokens: { backgroundColor: '#ffad00' }
        },
        {
          if: { purpose: 'offer' },
          tokens: { backgroundColor: '#7a3dfc', fontColor: '#ffffff' }
        },
        {
          if: { purpose: 'subtle' },
          tokens: { backgroundColor: '#a1ed00' }
        },
        {
          if: { wrap: true },
          tokens: { paddingBottom: 6, paddingTop: 6 }
        }
      ],
      tokens: {
        backgroundColor: '#a1ed00',
        borderRadius: 4,
        borderRadiusBottomLeft: null,
        borderRadiusBottomRight: null,
        boxShadowColor: null,
        boxShadowPaddingBottom: null,
        boxShadowPaddingLeft: null,
        boxShadowPaddingRight: null,
        boxShadowPaddingTop: null,
        curveAfterBackgroundColor: null,
        curveAfterHeight: null,
        curveAfterRadius: null,
        curveAfterWidth: null,
        curveBackgroundColor: null,
        curveHeight: null,
        curveMarginTop: null,
        curveWidth: null,
        fontColor: '#000000',
        fontName: 'StagSans',
        fontSize: 14,
        fontWeight: '600',
        gradient: null,
        lineHeight: 1.42857142857,
        paddingBottom: 2,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 2
      }
    },
    Search: {
      appearances: {
        focus: {
          description: 'Focus states for some input elements are well supported across web, RN, ios and android',
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        { if: { hover: true, inactive: null }, tokens: {} },
        {
          if: { focus: true },
          tokens: {
            borderColor: '#7a3dfc',
            borderWidth: 3,
            outerBorderWidth: 0
          }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#efefef',
            borderColor: '#efefef',
            color: '#666666',
            placeholderColor: '#000000'
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#000000',
        borderRadius: 4,
        borderWidth: 1,
        buttonsGap: 2,
        clearButtonIcon: PaletteIconTimes,
        color: '#666666',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '400',
        iconLeftColor: '#000000',
        iconLeftSize: 20,
        lineHeight: 1.5,
        mobileBorderWidth: 1,
        outerBackgroundColor: '#404040',
        outerBorderColor: '#404040',
        outerBorderRadius: 32,
        outerBorderWidth: 0,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 6,
        paddingTop: 12,
        placeholderColor: '#000000',
        submitButtonIcon: PaletteIconSpyglass
      }
    },
    SearchButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        priority: { description: '', type: 'variant', values: [ 'high' ] }
      },
      rules: [
        {
          if: { priority: 'high' },
          tokens: { backgroundColor: '#000000', iconColor: '#ffffff' }
        },
        {
          if: { hover: true },
          tokens: {
            backgroundColor: '#000000',
            borderWidth: 0,
            iconColor: '#ffffff'
          }
        },
        {
          if: { focus: true },
          tokens: {
            backgroundColor: 'transparent',
            borderColor: '#000000',
            borderWidth: 3,
            iconColor: '#000000'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#404040',
            borderWidth: 0,
            iconColor: '#666666'
          }
        },
        {
          if: { inactive: true, priority: 'high' },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 0,
            iconColor: '#666666'
          }
        },
        {
          if: { inactive: true, priority: null },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            iconColor: 'rgba(0, 0, 0, 0)'
          }
        }
      ],
      tokens: {
        backgroundColor: null,
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 32,
        borderWidth: 0,
        iconColor: '#000000',
        iconSize: 20,
        mobileBackgroundColor: null,
        opacity: 1,
        paddingBottom: 8,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 8,
        shadow: null
      }
    },
    Select: {
      appearances: {
        active: { type: 'state', values: [ true ] },
        focus: {
          description: 'Focus states for some input elements are well supported across web, RN, ios and android',
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success', 'warning', 'feature' ]
        }
      },
      rules: [
        {
          if: { focus: true },
          tokens: { borderColor: '#7a3dfc', borderWidth: 3 }
        },
        {
          if: { validation: 'success' },
          tokens: {
            borderColor: '#1c7b2b',
            feedbackBackgroundColor: '#c5f2cc',
            validationIcon: PaletteIconCheckCircleFilled,
            validationIconColor: '#1c7b2b'
          }
        },
        {
          if: { validation: 'error' },
          tokens: {
            borderColor: '#c9370b',
            feedbackBackgroundColor: '#fcd3c6',
            validationIcon: PaletteIconExclamationOctagon,
            validationIconColor: '#c9370b'
          }
        },
        {
          if: { hover: true },
          tokens: { backgroundColor: '#efefef', borderColor: '#000000' }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#efefef',
            borderColor: '#efefef',
            icon: null
          }
        },
        {
          if: { active: true },
          tokens: { icon: PaletteIconChevronUp }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#000000',
        borderRadius: 4,
        borderWidth: 1,
        color: '#000000',
        feedbackBackgroundColor: '#e0d8fc',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '400',
        height: 48,
        icon: PaletteIconChevronDown,
        iconColor: '#000000',
        iconSize: 24,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderWidth: 2,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        validationIcon: null,
        validationIconColor: 'rgba(0, 0, 0, 0)',
        validationIconSize: 24
      }
    },
    SideNav: {
      appearances: {},
      rules: [],
      tokens: { borderColor: '#c9c8c8', borderStyle: 'solid', borderWidth: 1 }
    },
    SideNavItem: {
      appearances: {
        active: {
          description: 'Used to mark currently active Item or and ItemGroup containing the currently active Item',
          type: 'state',
          values: [ true, false ]
        },
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        type: {
          description: '`parent` being the toggle button for an ItemsGroup, and `child` an element of the ItemGroup',
          type: 'state',
          values: [ 'child', 'parent' ]
        }
      },
      rules: [
        {
          if: { active: true },
          tokens: {
            accentBackgroundColor: '#000000',
            backgroundColor: '#efefef'
          }
        },
        {
          if: { type: 'child' },
          tokens: {
            accentBackgroundColor: 'rgba(0, 0, 0, 0)',
            fontName: 'StagSans',
            fontSize: 14,
            fontWeight: '400',
            lineHeight: 1.45,
            paddingBottom: 12,
            paddingLeft: 32,
            paddingRight: 16,
            paddingTop: 12
          }
        },
        {
          if: { active: true, expanded: true, type: 'parent' },
          tokens: {
            accentBackgroundColor: 'rgba(0, 0, 0, 0)',
            backgroundColor: 'rgba(0, 0, 0, 0)'
          }
        },
        { if: { hover: true }, tokens: { backgroundColor: '#efefef' } },
        { if: { focus: true }, tokens: { backgroundColor: '#efefef' } },
        {
          if: { active: true, type: 'child' },
          tokens: {
            accentBackgroundColor: '#000000',
            accentOffset: 24,
            accentPadding: 16,
            backgroundColor: 'rgba(0, 0, 0, 0)',
            fontName: 'StagSans',
            fontWeight: '600',
            lineHeight: 1.5,
            paddingBottom: 13,
            paddingTop: 13
          }
        },
        {
          if: { active: false, hover: true, type: 'child' },
          tokens: { accentBackgroundColor: 'rgba(0, 0, 0, 0)' }
        }
      ],
      tokens: {
        accentBackgroundColor: 'rgba(0, 0, 0, 0)',
        accentOffset: 0,
        accentPadding: 0,
        accentWidth: 4,
        backgroundColor: 'transparent',
        borderColor: '#c9c8c8',
        borderStyle: 'solid',
        borderWidth: 1,
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        justifyContent: 'space-between',
        lineHeight: 1.5,
        paddingBottom: 12,
        paddingLeft: 24,
        paddingRight: 20,
        paddingTop: 12
      }
    },
    SideNavItemsGroup: {
      appearances: {
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { expanded: true },
          tokens: { icon: PaletteIconChevronUp }
        }
      ],
      tokens: {
        collapseDuration: 250,
        contentPaddingBottom: 0,
        contentPaddingLeft: 0,
        contentPaddingRight: 0,
        contentPaddingTop: 0,
        expandDuration: 300,
        icon: PaletteIconChevronDown,
        iconColor: '#000000',
        iconGap: 8,
        iconPosition: 'right',
        iconSize: 16,
        justifyContent: 'space-between',
        verticalAlign: 'middle'
      }
    },
    Skeleton: {
      appearances: {},
      rules: [],
      tokens: {
        animationDuration: 2000,
        baseWidth: 40,
        characters: 10,
        color: '#c9c8c8',
        lineRadius: 4,
        radius: 99999999999999,
        secondColor: '#efefef',
        size: 3,
        spaceBetweenLines: 2,
        squareRadius: 4
      }
    },
    SkipLink: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { focus: true, pressed: true },
          tokens: { color: '#595959', outlineColor: '#595959' }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderRadius: 4,
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        lineHeight: 1.5,
        outlineColor: '#000000',
        outlineOffset: 0,
        outlineStyle: 'solid',
        outlineWidth: 2,
        paddingHorizontal: 2,
        paddingVertical: 2,
        textLine: 'underline'
      }
    },
    Spinner: {
      appearances: { size: { type: 'variant', values: [ 'small' ] } },
      rules: [ { if: { size: 'small' }, tokens: { size: 24, thickness: 2 } } ],
      tokens: {
        fullScreenOverLayBackground: 'rgba(255, 255, 255, 0.8)',
        size: 48,
        thickness: 4
      }
    },
    SplashButton: {
      appearances: {
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [],
      tokens: {
        buttonContentBackground: null,
        buttonContentChildrenBackground: null,
        playIcon: PaletteIconPlaySolid,
        playIconColor: '#ffffff'
      }
    },
    SplashButtonWithDetails: {
      appearances: {
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { buttonContentChildrenBackground: null }
        }
      ],
      tokens: {
        buttonBackground: '#ffffff',
        buttonBorderColor: null,
        buttonBottomPosition: 24,
        buttonContentBackground: null,
        buttonContentChildrenBackground: null,
        buttonLeftPosition: 24,
        buttonMinHeight: 64,
        buttonPaddingLeft: 16,
        buttonPaddingRight: 16,
        buttonRadius: 32,
        detailsContainerPadding: 8,
        labelFontName: 'StagSans',
        labelFontWeight: '600',
        playIcon: PaletteIconPlaySolid,
        playIconColor: '#ffffff',
        playIconContainerBackground: '#000000'
      }
    },
    StackView: {
      appearances: {},
      rules: [],
      tokens: {
        alignItems: 'stretch',
        flexGrow: 0,
        flexShrink: 0,
        justifyContent: 'flex-start',
        width: null
      }
    },
    Status: {
      appearances: {
        inverse: {
          description: 'Inverts the status colors',
          type: 'variant',
          values: [ true ]
        },
        priority: { type: 'variant', values: [ 'default', 'low', 'high' ] },
        purpose: {
          type: 'variant',
          values: [
            'default', 'brand',
            'subtle',  'success',
            'warning', 'error',
            'offer'
          ]
        }
      },
      rules: [
        { if: { purpose: 'brand' }, tokens: { iconColor: '#000000' } },
        {
          if: { purpose: 'subtle' },
          tokens: { icon: PaletteIconTooltip }
        },
        {
          if: { purpose: 'success' },
          tokens: {
            icon: PaletteIconCheckCircledFilled,
            iconColor: '#1c7b2b'
          }
        },
        {
          if: { purpose: 'warning' },
          tokens: {
            icon: PaletteIconExclamationTriangle,
            iconColor: '#c9370b'
          }
        },
        {
          if: { purpose: 'error' },
          tokens: {
            icon: PaletteIconExclamationOctagon,
            iconColor: '#c9370b'
          }
        },
        {
          if: { purpose: 'offer' },
          tokens: { icon: PaletteIconTagFilled, iconColor: '#7a3dfc' }
        },
        {
          if: { priority: 'low' },
          tokens: {
            borderRadius: 99,
            paddingBottom: 4,
            paddingLeft: 12,
            paddingRight: 12,
            paddingTop: 4
          }
        },
        {
          if: { priority: 'high' },
          tokens: {
            backgroundColor: '#000000',
            borderRadius: 99,
            iconColor: '#ffffff',
            paddingBottom: 4,
            paddingLeft: 12,
            paddingRight: 12,
            paddingTop: 4,
            textColor: '#ffffff'
          }
        },
        {
          if: { priority: 'low', purpose: 'default' },
          tokens: { backgroundColor: '#efefef' }
        },
        {
          if: { priority: 'high', purpose: 'default' },
          tokens: { backgroundColor: '#000000' }
        },
        {
          if: { priority: 'low', purpose: 'brand' },
          tokens: { backgroundColor: '#efefef' }
        },
        {
          if: { priority: 'high', purpose: 'brand' },
          tokens: { backgroundColor: '#000000' }
        },
        {
          if: { priority: 'low', purpose: 'subtle' },
          tokens: { backgroundColor: '#efefef' }
        },
        {
          if: { priority: 'high', purpose: 'subtle' },
          tokens: {
            backgroundColor: '#c9c8c8',
            iconColor: '#000000',
            textColor: '#000000'
          }
        },
        {
          if: { priority: 'low', purpose: 'success' },
          tokens: { backgroundColor: '#c5f2cc' }
        },
        {
          if: { priority: 'high', purpose: 'success' },
          tokens: { backgroundColor: '#1c7b2b' }
        },
        {
          if: { priority: 'low', purpose: 'warning' },
          tokens: { backgroundColor: '#fff5d2' }
        },
        {
          if: { priority: 'high', purpose: 'warning' },
          tokens: { backgroundColor: '#c9370b' }
        },
        {
          if: { priority: 'low', purpose: 'error' },
          tokens: { backgroundColor: '#fcd3c6' }
        },
        {
          if: { priority: 'high', purpose: 'error' },
          tokens: { backgroundColor: '#c9370b' }
        },
        {
          if: { priority: 'low', purpose: 'offer' },
          tokens: { backgroundColor: '#e0d8fc' }
        },
        {
          if: { priority: 'high', purpose: 'offer' },
          tokens: { backgroundColor: '#7a3dfc' }
        },
        {
          if: { inverse: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            iconColor: '#ffffff',
            textColor: '#ffffff'
          }
        },
        {
          if: { inverse: true, priority: 'low' },
          tokens: { backgroundColor: 'rgba(0, 0, 0, 0)' }
        },
        {
          if: { inverse: true, priority: 'high' },
          tokens: {
            backgroundColor: '#ffffff',
            iconColor: '#000000',
            textColor: '#000000'
          }
        }
      ],
      tokens: {
        backgroundColor: null,
        backgroundGradient: null,
        borderColor: null,
        borderRadius: null,
        borderWidth: null,
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '400',
        icon: PaletteIconToolTipFilled,
        iconColor: '#000000',
        iconGradient: null,
        iconPaddingTop: 0,
        iconSize: 20,
        marginLeft: 8,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        textColor: '#000000',
        textLineHeight: 1.14285714286
      }
    },
    StepTracker: {
      appearances: {
        inverse: {
          description: 'Styles the step tracker for using on dark backgrounds.',
          type: 'variant',
          values: [ true ]
        },
        style: { type: 'variant', values: [ 'default', 'bar' ] },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'lg', 'xl' ] },
          tokens: { showStepLabel: true, showStepTrackerLabel: false }
        },
        {
          if: { inverse: true },
          tokens: {
            completedIconColor: '#666666',
            connectorColor: '#ffffff',
            connectorCompletedColor: '#ffffff',
            knobBackgroundColor: 'transparent',
            knobBorderColor: '#ffffff',
            knobCompletedBackgroundColor: '#ffffff',
            knobCompletedBorderColor: 'transparent',
            knobCurrentBackgroundColor: 'transparent',
            knobCurrentBorderColor: '#ffffff',
            knobCurrentInnerColor: '#ffffff',
            labelColor: '#ffffff',
            labelCurrentColor: '#ffffff',
            stepLabelColor: '#ffffff'
          }
        },
        { if: { style: 'bar' }, tokens: { barGap: 4, barHeight: 8 } }
      ],
      tokens: {
        barBackgroundColor: 'rgba(0, 0, 0, 0.1)',
        barCompletedBackgroundColor: '#000000',
        barCurrentBackgroundColor: '#7a3dfc',
        barGap: null,
        barHeight: null,
        completedIcon: PaletteIconCheck,
        completedIconColor: '#ffffff',
        completedIconSize: 10,
        connectorColor: '#000000',
        connectorCompletedColor: '#000000',
        connectorCompletedHeight: 3,
        connectorHeight: 1,
        connectorMinWidth: 16,
        containerPaddingBottom: null,
        containerPaddingLeft: null,
        containerPaddingRight: null,
        containerPaddingTop: null,
        knobBackgroundColor: 'rgba(0, 0, 0, 0)',
        knobBorderColor: '#000000',
        knobBorderWidth: 1,
        knobCompletedBackgroundColor: '#000000',
        knobCompletedBorderColor: '#000000',
        knobCompletedPaddingLeft: 0,
        knobCompletedPaddingTop: 0,
        knobCurrentBackgroundColor: '#000000',
        knobCurrentBorderColor: '#000000',
        knobCurrentBorderWidth: 1,
        knobCurrentInnerColor: null,
        knobCurrentInnerSize: null,
        knobCurrentPaddingLeft: 0,
        knobCurrentPaddingTop: 0,
        knobSize: 15,
        labelColor: '#000000',
        labelCurrentColor: '#000000',
        labelCurrentFontName: 'StagSans',
        labelCurrentFontWeight: '600',
        labelDirection: 'row',
        labelFontName: 'StagSans',
        labelFontSize: 16,
        labelFontWeight: '600',
        labelGap: 4,
        labelLineHeight: 1.5,
        labelMarginTop: 10,
        labelPaddingLeft: 16,
        labelPaddingRight: 16,
        showStepLabel: false,
        showStepName: true,
        showStepTrackerLabel: true,
        stepLabelColor: '#000000',
        stepLabelFontName: 'StagSans',
        stepLabelFontSize: 16,
        stepLabelFontWeight: '600',
        stepLabelLineHeight: 1.5,
        textStepTrackerLabel: 2
      }
    },
    StoryCard: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        { if: { hover: true }, tokens: { borderWidth: 2 } },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#efefef' }
        },
        {
          if: { focus: true },
          tokens: {
            outerBorderColor: '#000000',
            outerBorderGap: 2,
            outerBorderWidth: 2
          }
        }
      ],
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#c9c8c8',
        borderRadius: 8,
        borderWidth: 1,
        contentAlignItems: 'stretch',
        contentFlexGrow: 0,
        contentFlexShrink: 0,
        contentJustifyContent: 'flex-start',
        flex: 1,
        minWidth: 0,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 0,
        outerBorderWidth: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        shadow: {
          blur: 0,
          color: 'rgba(0, 0, 0, 0)',
          inset: false,
          offsetX: 0,
          offsetY: 0,
          spread: 0
        }
      }
    },
    TabBar: {
      appearances: {
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { pressed: true },
          tokens: { paddingBottom: 0, paddingTop: 0 }
        }
      ],
      tokens: {
        backgroundColor: '#fafafa',
        borderTopColor: '#efefef',
        borderTopWidth: 1,
        gap: 8,
        paddingBottom: 4,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 4
      }
    },
    TabBarItem: {
      appearances: {
        focus: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { focus: true },
          tokens: {
            backgroundColor: '#efefef',
            color: '#000000',
            iconColor: '#000000',
            iconSize: 26
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: '#5b2bc2',
            iconColor: '#5b2bc2',
            iconSize: 22
          }
        },
        { if: { hover: true }, tokens: { iconSize: 26 } }
      ],
      tokens: {
        activeColor: '#7a3dfc',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 4,
        color: '#000000',
        fontName: 'StagSans',
        fontWeight: '600',
        iconColor: '#000000',
        iconSize: 24,
        lineHeight: 1.33333333333,
        paddingBottom: 4,
        paddingTop: 4
      }
    },
    Table: {
      appearances: {
        highlight: { type: 'variant', values: [ 'row' ] },
        spacing: {
          description: 'Adjusts the height of the table cell',
          type: 'variant',
          values: [ 'compact', 'default' ]
        },
        text: { type: 'variant', values: [ 'small' ] },
        type: {
          type: 'variant',
          values: [ 'subHeading', 'rowHeading', 'heading', 'default' ]
        }
      },
      rules: [
        {
          if: { highlight: 'row' },
          tokens: {
            cellBackground: 'rgba(0, 0, 0, 0)',
            rowHoverBackgroundColor: 'rgba(0, 0, 0, 0.05)'
          }
        },
        {
          if: { spacing: 'compact' },
          tokens: {
            cellPaddingBottom: 8,
            cellPaddingTop: 8,
            fontSize: 16,
            lineHeight: 1.25
          }
        },
        {
          if: { spacing: 'compact', type: 'rowHeading' },
          tokens: {
            cellPaddingBottom: 8,
            cellPaddingTop: 8,
            fontName: 'StagSans',
            fontSize: 16,
            fontWeight: '600',
            lineHeight: 1.25
          }
        },
        {
          if: { spacing: 'compact', type: 'subHeading' },
          tokens: {
            cellPaddingBottom: 8,
            cellPaddingTop: 8,
            fontName: 'StagSans',
            fontSize: 16,
            fontWeight: '600',
            lineHeight: 1.25
          }
        },
        {
          if: { spacing: 'default', type: 'heading' },
          tokens: {
            cellBackground: '#000000',
            cellBoxShadowColor: 'rgba(0, 0, 0, 0)',
            fontColor: '#ffffff',
            fontName: 'StagSans',
            fontSize: 16,
            fontWeight: '600',
            lineHeight: 1.5
          }
        },
        {
          if: { spacing: 'compact', type: 'heading' },
          tokens: {
            cellBackground: '#000000',
            cellBoxShadowColor: 'rgba(0, 0, 0, 0)',
            cellPaddingBottom: 8,
            cellPaddingTop: 8,
            fontColor: '#ffffff',
            fontName: 'StagSans',
            fontSize: 16,
            fontWeight: '600',
            lineHeight: 1.25
          }
        },
        {
          if: { text: 'small', type: 'subHeading' },
          tokens: { fontName: 'StagSans', fontSize: 16, fontWeight: '600' }
        },
        {
          if: { spacing: 'default', type: 'rowHeading' },
          tokens: {
            fontName: 'StagSans',
            fontSize: 16,
            fontWeight: '600',
            lineHeight: 1.5
          }
        },
        {
          if: { text: 'small', type: 'default' },
          tokens: {
            fontName: 'StagSans',
            fontSize: 14,
            fontWeight: '400',
            lineHeight: 1.42857142857
          }
        },
        {
          if: { text: 'small', type: 'rowHeading' },
          tokens: {
            fontName: 'StagSans',
            fontSize: 14,
            fontWeight: '600',
            lineHeight: 1.42857142857
          }
        },
        {
          if: { spacing: 'compact', text: 'small', type: 'rowHeading' },
          tokens: {
            fontName: 'StagSans',
            fontSize: 14,
            fontWeight: '600',
            lineHeight: 1.14285714286
          }
        },
        {
          if: { spacing: 'compact', text: 'small', type: 'default' },
          tokens: { lineHeight: 1.14285714286 }
        }
      ],
      tokens: {
        borderColor: '#efefef',
        borderWidth: 1,
        cellBackground: '#ffffff',
        cellBorderColor: 'rgba(0, 0, 0, 0)',
        cellBorderTopWidth: 0,
        cellBorderWidth: 0,
        cellBoxShadowColor: '#efefef',
        cellMinWidth: 0,
        cellPaddingBottom: 16,
        cellPaddingLeft: 16,
        cellPaddingRight: 16,
        cellPaddingTop: 16,
        cellStickyShadow: {
          blur: 8,
          color: 'rgba(0, 0, 0, 0.1)',
          inset: false,
          offsetX: 0,
          offsetY: 4,
          spread: 0
        },
        display: null,
        fontColor: '#000000',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '400',
        lineHeight: 1.5,
        rowBorderColor: 'rgba(0, 0, 0, 0)',
        rowBorderTopWidth: 0,
        rowBorderWidth: 0,
        rowHoverBackgroundColor: 'rgba(0, 0, 0, 0)',
        stickyBackgroundColor: '#ffffff',
        tablePaddingBottom: 24
      }
    },
    Tabs: {
      appearances: {
        equalWidth: {
          description: 'Divide the available width equally among `TabsItem`',
          type: 'variant',
          values: [ true ]
        }
      },
      rules: [],
      tokens: {
        borderBottomColor: 'transparent',
        borderBottomWidth: 0,
        buttonClearance: 32,
        gutter: null,
        nextIcon: PaletteIconChevronRight,
        previousIcon: PaletteIconChevronLeft,
        space: 0
      }
    },
    TabsItem: {
      appearances: {
        dropdown: {
          description: 'activate the dropdown menu',
          type: 'variant',
          values: [ true ]
        },
        equalWidth: {
          description: 'Divide the available width equally among `TabsItem`',
          type: 'variant',
          values: [ true ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { selected: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderRadius: 99,
            color: '#000000',
            highlightBarBorderWidth: 1,
            highlightBarHeight: 1,
            highlightColor: '#000000'
          }
        },
        {
          if: { hover: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderRadius: 99,
            highlightBarBorderWidth: 0,
            highlightBarHeight: 1,
            highlightColor: '#c9c8c8'
          }
        },
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            borderRadius: 99,
            highlightBarBorderWidth: 0
          }
        },
        {
          if: { focus: true, selected: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            borderColor: '#000000',
            borderRadius: 99,
            borderWidth: 2,
            color: '#000000',
            highlightBarBorderWidth: 1,
            highlightBarHeight: 1,
            highlightColor: '#000000'
          }
        },
        {
          if: { hover: true, selected: true },
          tokens: {
            highlightBarBorderWidth: 1,
            highlightBarHeight: 1,
            highlightColor: '#000000'
          }
        },
        {
          if: { focus: true },
          tokens: {
            borderColor: '#000000',
            borderRadius: 99,
            borderWidth: 2,
            color: '#000000'
          }
        },
        {
          if: { inverse: true },
          tokens: { backgroundColor: 'transparent', color: '#ffffff' }
        },
        {
          if: { inverse: true, selected: true },
          tokens: {
            backgroundColor: '#ffffff',
            borderRadius: 99,
            color: '#000000',
            highlightBarBorderWidth: 1,
            highlightBarHeight: 1,
            highlightColor: '#ffffff'
          }
        },
        {
          if: { hover: true, inverse: true },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: 99,
            color: '#ffffff'
          }
        },
        {
          if: { focus: true, inverse: true, selected: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#ffffff',
            borderRadius: 99,
            borderWidth: 2,
            color: '#000000'
          }
        },
        {
          if: { focus: true, inverse: true },
          tokens: {
            borderColor: '#ffffff',
            borderRadius: 99,
            borderWidth: 2,
            color: '#ffffff'
          }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            borderRadius: 99,
            highlightBarBorderWidth: 0
          }
        },
        {
          if: { focus: true, inverse: true, selected: true },
          tokens: {}
        },
        { if: { equalWidth: true }, tokens: { maxWidth: null } },
        {
          if: { dropdown: true, viewport: [ 'xs', 'sm' ] },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderRadius: 32,
            borderWidth: 1,
            color: '#000000'
          }
        },
        {
          if: { dropdown: true, hover: true, viewport: [ 'xs', 'sm' ] },
          tokens: { backgroundColor: 'rgba(0, 0, 0, 0.1)' }
        },
        {
          if: { dropdown: true, focus: true, viewport: [ 'xs', 'sm' ] },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#000000',
            borderWidth: 1,
            color: '#000000'
          }
        },
        {
          if: { dropdown: true, pressed: true, viewport: [ 'xs', 'sm' ] },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#000000'
          }
        },
        {
          if: { dropdown: true, selected: true, viewport: [ 'xs', 'sm' ] },
          tokens: { backgroundColor: 'rgba(0, 0, 0, 0.1)', color: '#000000' }
        },
        {
          if: { dropdown: true, inverse: true, viewport: [ 'xs', 'sm' ] },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 1,
            color: '#ffffff'
          }
        },
        {
          if: {
            dropdown: true,
            hover: true,
            inverse: true,
            viewport: [ 'xs', 'sm' ]
          },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            color: '#ffffff'
          }
        },
        {
          if: {
            dropdown: true,
            inverse: true,
            selected: true,
            viewport: [ 'xs', 'sm' ]
          },
          tokens: { backgroundColor: '#ffffff', color: '#000000' }
        },
        {
          if: {
            dropdown: true,
            focus: true,
            inverse: true,
            viewport: [ 'xs', 'sm' ]
          },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#ffffff',
            borderWidth: 1
          }
        },
        {
          if: {
            dropdown: true,
            inverse: true,
            pressed: true,
            viewport: [ 'xs', 'sm' ]
          },
          tokens: {
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            borderColor: 'rgba(0, 0, 0, 0)',
            color: '#ffffff'
          }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: 'transparent',
        borderRadius: 0,
        borderWidth: 0,
        color: '#000000',
        dropdownIcon: PaletteIconChevronDown,
        dropdownIconExpanded: PaletteIconChevronUp,
        fontName: 'StagSans',
        fontScaleCap: 64,
        fontSize: 16,
        fontWeight: '600',
        highlightBarBorderRadius: 0,
        highlightBarBorderWidth: 0,
        highlightBarHeight: 0,
        highlightColor: 'transparent',
        highlightTriangleSize: 0,
        letterSpacing: 0,
        lineHeight: 1.5,
        marginHorizontal: 4,
        marginVertical: 0,
        maxWidth: null,
        paddingHorizontal: 24,
        paddingVertical: 4,
        space: 1,
        textAlign: 'center',
        textTransform: 'none'
      }
    },
    Tags: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [ { if: { viewport: [ 'lg', 'xl' ] }, tokens: { space: 3 } } ],
      tokens: {
        alignItems: 'center',
        direction: 'row',
        flexGrow: 0,
        flexShrink: 0,
        justifyContent: 'flex-start',
        space: 1
      }
    },
    TagsItem: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { pressed: true },
          tokens: {
            backgroundColor: '#404040',
            borderColor: '#404040',
            borderWidth: 0,
            color: '#ffffff',
            iconBackground: '#404040',
            iconColor: '#ffffff',
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            outerBorderWidth: 0
          }
        },
        {
          if: { focus: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            borderColor: '#000000',
            color: '#000000',
            iconBackground: 'rgba(0, 0, 0, 0)',
            iconColor: '#000000',
            outerBorderColor: '#000000',
            outerBorderGap: 3,
            outerBorderWidth: 1
          }
        },
        {
          if: { hover: true },
          tokens: {
            backgroundColor: '#404040',
            borderColor: '#404040',
            borderWidth: 0,
            color: '#ffffff',
            iconBackground: '#404040',
            iconColor: '#ffffff'
          }
        },
        {
          if: { selected: true },
          tokens: {
            backgroundColor: '#000000',
            borderColor: '#000000',
            color: '#ffffff',
            icon: PaletteIconClose,
            iconBackground: '#000000',
            iconColor: '#ffffff',
            iconPadding: 4,
            outerBorderColor: 'rgba(0, 0, 0, 0)',
            outerBorderWidth: 0
          }
        },
        {
          if: { hover: true, selected: true },
          tokens: { backgroundColor: '#404040', iconBackground: '#404040' }
        },
        {
          if: { focus: true, selected: true },
          tokens: {
            backgroundColor: '#000000',
            outerBorderColor: '#000000',
            outerBorderWidth: 1
          }
        },
        {
          if: { focus: true, hover: true, selected: true },
          tokens: { backgroundColor: '#404040', iconBackground: '#404040' }
        },
        {
          if: { focus: true, pressed: true, selected: true },
          tokens: { backgroundColor: '#404040', iconBackground: '#404040' }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#efefef',
            borderWidth: 0,
            color: '#c9c8c8',
            iconBackground: '#efefef',
            iconColor: '#c9c8c8'
          }
        }
      ],
      tokens: {
        alignSelf: 'center',
        backgroundColor: '#ffffff',
        borderColor: '#000000',
        borderRadius: 4,
        borderWidth: 1,
        color: '#000000',
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '600',
        icon: PaletteIconAdd,
        iconAlignSelf: 'center',
        iconBackground: '#ffffff',
        iconBorderRadius: 32,
        iconColor: '#000000',
        iconPadding: 2,
        iconPosition: 'right',
        iconSize: 16,
        iconSpace: 2,
        iconTranslateX: 0,
        iconTranslateY: 0,
        lineHeight: 1.5,
        minWidth: 0,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderWidth: 0,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        shadow: null,
        textAlign: 'center'
      }
    },
    TermsAndConditions: {
      appearances: {
        expanded: {
          description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
          type: 'state',
          values: [ true, false ]
        },
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: {
            expandContentPaddingRight: 24,
            listMarginLeft: 2,
            titlePaddingLeft: 2
          }
        },
        {
          if: { expanded: true },
          tokens: { icon: PaletteIconChevronUp }
        },
        {
          if: { hover: true },
          tokens: {
            iconBackgroundColor: '#000000',
            iconColor: '#ffffff',
            iconOuterBorderGap: 2
          }
        },
        {
          if: { pressed: true },
          tokens: {
            iconBackgroundColor: '#404040',
            iconColor: '#ffffff',
            iconOuterBorderGap: 2
          }
        },
        {
          if: { focus: true },
          tokens: {
            iconOuterBorderColor: '#000000',
            iconOuterBorderGap: 2,
            iconOuterBorderWidth: 1
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: {
            iconBackgroundColor: '#404040',
            iconColor: '#666666',
            iconOuterBorderGap: 2
          }
        }
      ],
      tokens: {
        contentBorderColor: 'transparent',
        contentMarginBottom: 0,
        contentPaddingBottom: 8,
        contentPaddingLeft: 16,
        dividerColor: '#c9c8c8',
        expandBaseBorderWidth: 0,
        expandContentPaddingBottom: 16,
        expandContentPaddingLeft: 16,
        expandContentPaddingRight: 16,
        expandContentPaddingTop: 16,
        expandIconContainerAlignItems: 'center',
        expandIconContainerBorder: 0,
        expandIconContainerBorderColor: 'rgba(0, 0, 0, 0)',
        expandIconContainerHeight: 32,
        expandIconContainerJustifyContent: 'center',
        expandIconContainerMarginX: 0,
        expandIconContainerMarginY: 12,
        expandIconContainerWidth: 32,
        expandTitleBorder: 0,
        expandTitleBorderColor: 'rgba(0, 0, 0, 0)',
        expandTitleColor: '#000000',
        expandTitleFontName: 'StagSans',
        expandTitleFontSize: 16,
        expandTitleFontWeight: '600',
        expandTitleLineHeight: 1.5,
        expandTitleMarginX: 4,
        expandTitleMarginY: 0,
        expandTitlePaddingLeft: 0,
        expandTitleUnderline: 'none',
        headerBackgroundColor: 'rgba(0, 0, 0, 0)',
        icon: PaletteIconChevronDown,
        iconBackgroundColor: 'rgba(0, 0, 0, 0)',
        iconBorderColor: 'rgba(0, 0, 0, 0)',
        iconColor: '#000000',
        iconOuterBorderColor: 'rgba(0, 0, 0, 0)',
        iconOuterBorderGap: 0,
        iconOuterBorderWidth: 0,
        listColor: '#000000',
        listFontName: 'StagSans',
        listFontSize: 14,
        listFontWeight: '400',
        listLineHeight: 1.42857142857,
        listMarginBottom: 16,
        listMarginLeft: 32,
        mdContentPaddingBottom: 16,
        mdContentPaddingLeft: 48,
        orderedPadding: 0,
        titleColor: '#016b6a',
        titleFontSize: 14,
        titleLineHeight: 1.42857142857,
        titlePaddingLeft: 32,
        unorderedPadding: 12
      }
    },
    Testimonial: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'md', 'lg', 'xl' ] },
          tokens: {
            testimonialFontNameHeading: 'StagSans',
            testimonialFontSizeHeading: 32,
            testimonialFontWeightHeading: '700',
            testimonialLineHeightHeading: 1.25
          }
        }
      ],
      tokens: {
        additionalFontName: 'StagSans',
        additionalFontSize: 14,
        additionalFontWeight: '400',
        additionalLineHeight: 1.42857142857,
        authorFontName: 'StagSans',
        authorFontSize: 16,
        authorFontWeight: '600',
        authorLineHeight: 1.5,
        dividerBackgroundColor: '#c9c8c8',
        dividerBorder: 1,
        figcaptionGap: 12,
        icon: PaletteIconQuoteLeft,
        iconColor: '#c9c8c8',
        iconFr: PaletteIconQuoteRightArrow,
        imageSize: 48,
        quoteContainerGap: 4,
        testimonialContainerGap: 12,
        testimonialFontNameHeading: 'StagSans',
        testimonialFontNameLarge: 'StagSans',
        testimonialFontSizeHeading: 24,
        testimonialFontSizeLarge: 20,
        testimonialFontWeightHeading: '700',
        testimonialFontWeightLarge: '400',
        testimonialLineHeightHeading: 1.33333333333,
        testimonialLineHeightLarge: 1.4,
        textColor: '#000000'
      }
    },
    TextArea: {
      appearances: {},
      rules: [],
      tokens: { maxLines: 4, minLines: 2 }
    },
    TextInput: {
      appearances: {
        focus: {
          description: 'Focus states for some input elements are well supported across web, RN, ios and android',
          type: 'state',
          values: [ true ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        numeric: {
          description: 'capability to only allow numbers',
          type: 'variant',
          values: [ true ]
        },
        password: {
          description: 'capability that helps masking and unmasking text',
          type: 'variant',
          values: [ true ]
        },
        validation: {
          description: 'Validation states for form inputs',
          type: 'state',
          values: [ 'error', 'success', 'warning', 'feature' ]
        }
      },
      rules: [
        {
          if: { hover: true, inactive: null },
          tokens: { backgroundColor: '#efefef', borderColor: '#000000' }
        },
        {
          if: { hover: true, validation: 'success' },
          tokens: {
            backgroundColor: '#efefef',
            borderColor: '#000000',
            icon: PaletteIconCheckCircleFilled,
            iconColor: '#1c7b2b'
          }
        },
        {
          if: { hover: true, validation: 'error' },
          tokens: {
            backgroundColor: '#efefef',
            borderColor: '#000000',
            iconColor: '#c9370b'
          }
        },
        {
          if: { hover: false, validation: 'success' },
          tokens: {
            borderColor: '#1c7b2b',
            icon: PaletteIconCheckCircleFilled,
            iconColor: '#1c7b2b'
          }
        },
        {
          if: { hover: false, validation: 'error' },
          tokens: {
            borderColor: '#c9370b',
            icon: PaletteIconExclamationOctagon,
            iconColor: '#c9370b'
          }
        },
        {
          if: { focus: true, inactive: null },
          tokens: { borderColor: '#7a3dfc', borderWidth: 3, icon: null }
        },
        {
          if: { inactive: true },
          tokens: { backgroundColor: '#efefef', borderColor: '#efefef' }
        }
      ],
      tokens: {
        amexIcon: PaletteIconAmex,
        backgroundColor: '#ffffff',
        borderColor: '#000000',
        borderRadius: 4,
        borderWidth: 1,
        buttonSize: 32,
        buttonsGap: 0,
        buttonsPaddingRight: 0,
        clearButtonIcon: PaletteIconTimes,
        color: '#000000',
        defaultCreditIcon: PaletteIconCreditCard,
        fontName: 'StagSans',
        fontSize: 16,
        fontWeight: '400',
        icon: null,
        iconColor: 'rgba(0, 0, 0, 0)',
        iconLeftGap: 5,
        iconLeftPaddingBottom: 5,
        iconSize: 24,
        leftIconPaddingBottom: 5,
        lineHeight: 1.5,
        masterCardIcon: PaletteIconMasterCard,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderWidth: 0,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        passwordHideButtonIcon: PaletteIconEyeMasked,
        passwordShowButtonIcon: PaletteIconEyeUnmasked,
        visaIcon: PaletteIconVisa
      }
    },
    Timeline: {
      appearances: {
        horizontal: {
          description: 'Use horizontal to display timeline horizontally.',
          type: 'variant',
          values: [ true ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { horizontal: true, viewport: [ 'lg', 'xl' ] },
          tokens: {
            connectorHeight: 1,
            connectorWidth: '100%',
            itemContentMarginBottom: 0,
            itemContentMarginRight: 32,
            lineItemContainerDirection: 'column',
            lineItemDirection: 'row',
            lineItemMarginBottom: 24,
            lineItemMarginRight: 0,
            timelineContainerDirection: 'row'
          }
        }
      ],
      tokens: {
        connectorHeight: '100%',
        connectorWidth: 1,
        dotBorderWidth: 2,
        dotColor: '#ffffff',
        dotWidth: 12,
        itemContentFlexSize: 1,
        itemContentMarginBottom: 32,
        itemContentMarginRight: 0,
        lineContainerFlexSize: 1,
        lineItemAlign: 'center',
        lineItemContainerDirection: 'row',
        lineItemDirection: 'column',
        lineItemMarginBottom: 0,
        lineItemMarginRight: 24,
        timelineColor: '#000000',
        timelineConnectorColor: '#000000',
        timelineContainerDirection: 'column'
      }
    },
    Toast: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs' ] },
          tokens: {
            animationPaddingBottomAfter: 8,
            animationPaddingTopAfter: 8
          }
        }
      ],
      tokens: {
        animationBackgroundColorAfter: '#efefef',
        animationBackgroundColorBefore: '#000000',
        animationColorAfter: '#000000',
        animationColorBefore: '#ffffff',
        animationDivColorAfter: '#000000',
        animationDivColorBefore: '#ffffff',
        animationHeightAfter: 24,
        animationHeightBefore: 0,
        animationPaddingBottomAfter: 16,
        animationPaddingBottomBefore: 0,
        animationPaddingTopAfter: 16,
        animationPaddingTopBefore: 0,
        chevronlinkFontName: 'StagSans',
        chevronlinkFontWeight: '400',
        containerBackgroundColor: '#000000',
        containerGap: 12,
        padding: 16
      }
    },
    ToggleSwitch: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inactive: {
          description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
          type: 'state',
          values: [ true ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: { backgroundColor: '#c9c8c8', switchColor: '#666666' }
        },
        {
          if: { pressed: true },
          tokens: { backgroundColor: '#c9c8c8', switchColor: '#595959' }
        },
        {
          if: { focus: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            outerBorderColor: '#000000',
            outerBorderGap: 3,
            outerBorderWidth: 1,
            switchColor: '#666666'
          }
        },
        {
          if: { selected: true },
          tokens: {
            backgroundColor: '#fafafa',
            icon: PaletteIconCheck,
            iconColor: '#ffffff',
            switchBorderColor: 'rgba(0, 0, 0, 0)',
            switchColor: '#000000'
          }
        },
        {
          if: { hover: true, selected: true },
          tokens: { backgroundColor: '#c9c8c8', switchColor: '#404040' }
        },
        {
          if: { pressed: true, selected: true },
          tokens: { backgroundColor: '#c9c8c8', switchColor: '#666666' }
        },
        {
          if: { focus: true, selected: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            icon: PaletteIconCheck,
            iconColor: '#ffffff',
            outerBorderColor: '#000000',
            outerBorderWidth: 1,
            switchBorderColor: 'rgba(0, 0, 0, 0)',
            switchColor: '#000000'
          }
        },
        {
          if: { focus: true, pressed: true },
          tokens: {
            outerBorderColor: '#000000',
            outerBorderGap: 3,
            outerBorderWidth: 1
          }
        },
        {
          if: { focus: true, pressed: true, selected: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            icon: PaletteIconCheck,
            iconColor: '#ffffff',
            outerBorderColor: '#000000',
            outerBorderGap: 3,
            outerBorderWidth: 1,
            switchColor: '#666666'
          }
        },
        {
          if: { inactive: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            opacity: 0.5,
            switchBorderColor: 'rgba(0, 0, 0, 0)',
            switchColor: '#c9c8c8'
          }
        },
        {
          if: { inactive: true, selected: true },
          tokens: {
            backgroundColor: '#c9c8c8',
            icon: PaletteIconCheck,
            iconColor: '#ffffff',
            opacity: 0.5,
            switchBorderColor: 'rgba(0, 0, 0, 0)',
            switchColor: '#c9c8c8'
          }
        }
      ],
      tokens: {
        alignSelf: 'flex-start',
        backgroundColor: '#c9c8c8',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 32,
        borderWidth: 0,
        containerWidth: null,
        icon: null,
        iconColor: null,
        iconSize: 12,
        labelColor: '#000000',
        labelFontName: 'StagSans',
        labelFontSize: 16,
        labelFontWeight: '600',
        labelLineHeight: 1.5,
        labelMarginLeft: 0,
        mobileSwitchSize: 24,
        mobileTrackBorderWidth: 4,
        mobileTrackHeight: 32,
        mobileWidth: 48,
        opacity: 1,
        outerBackgroundColor: 'rgba(0, 0, 0, 0)',
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 0,
        outerBorderGapButton: 4,
        outerBorderWidth: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        shadow: null,
        space: 2,
        switchBorderColor: 'rgba(0, 0, 0, 0)',
        switchBorderRadius: 32,
        switchBorderWidth: 0,
        switchColor: '#595959',
        switchShadow: {
          blur: 2,
          color: 'rgba(0, 0, 0, 0.2)',
          inset: false,
          offsetX: 0,
          offsetY: 2,
          spread: 0
        },
        switchSize: 24,
        trackBorderColor: 'rgba(0, 0, 0, 0)',
        trackBorderRadius: 12,
        trackBorderWidth: 3,
        trackHeight: 20,
        width: 40
      }
    },
    ToggleSwitchGroup: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [ { if: { viewport: [ 'lg', 'xl' ] }, tokens: { space: 3 } } ],
      tokens: {
        alignItems: 'flex-start',
        direction: 'column',
        fieldSpace: 2,
        flexGrow: 0,
        flexShrink: 0,
        justifyContent: 'flex-start',
        space: 3
      }
    },
    Tooltip: {
      appearances: { inverse: { type: 'variant', values: [ true ] } },
      rules: [
        {
          if: { inverse: true },
          tokens: { backgroundColor: '#ffffff', color: '#000000' }
        }
      ],
      tokens: {
        arrowBorderRadius: 0,
        arrowOffset: 4,
        arrowWidth: 8,
        backgroundColor: '#595959',
        borderRadius: 4,
        color: '#ffffff',
        fontName: 'StagSans',
        fontSize: 14,
        fontWeight: '400',
        lineHeight: 1.4,
        maxWidth: 288,
        minWidth: 0,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        shadow: {
          blur: 0,
          color: 'rgba(0, 0, 0, 0)',
          inset: false,
          offsetX: 0,
          offsetY: 0,
          spread: 0
        }
      }
    },
    TooltipButton: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        inverse: { type: 'variant', values: [ true ] },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        }
      },
      rules: [
        {
          if: { hover: true },
          tokens: {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            iconColor: '#7a3dfc',
            iconScale: 1.25
          }
        },
        {
          if: { inverse: true },
          tokens: { backgroundColor: 'rgba(0, 0, 0, 0)', iconColor: '#ffffff' }
        },
        {
          if: { hover: true, inverse: true },
          tokens: { iconColor: '#ffffff' }
        },
        {
          if: { focus: true, inverse: true },
          tokens: { outerBorderColor: '#ffffff' }
        },
        {
          if: { focus: true, inverse: null },
          tokens: { outerBorderColor: '#000000' }
        },
        {
          if: { inverse: true, pressed: true },
          tokens: {
            backgroundColor: '#ffffff',
            icon: PaletteIconTooltipSymbol,
            iconColor: '#000000',
            outerBorderColor: '#efefef'
          }
        },
        {
          if: { inverse: null, pressed: true },
          tokens: {
            backgroundColor: '#5b2bc2',
            iconColor: '#ffffff',
            outerBorderColor: '#5b2bc2'
          }
        }
      ],
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 32,
        icon: PaletteIconTooltip,
        iconColor: '#000000',
        iconScale: 1,
        iconSize: 16,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 4,
        outerBorderWidth: 1,
        width: 16
      }
    },
    Typography: {
      appearances: {
        bold: {
          description: 'Sets the font weight, to bold on some body text styles. Does not change accessibility properties.',
          type: 'variant',
          values: [ true ]
        },
        colour: {
          type: 'variant',
          values: [
            'default',      'brand',
            'dark',         'light',
            'positive',     'warning',
            'danger',       'black',
            'white',        'brand2',
            'brand3',       'alternative1',
            'alternative2', 'alternative3'
          ]
        },
        compact: {
          description: 'Reduces line height on some body text styles. For data-rich content, not for flow content',
          type: 'variant',
          values: [ true ]
        },
        inverse: {
          description: 'Styles the link white for use on dark backgrounds.',
          type: 'variant',
          values: [ true ]
        },
        size: {
          type: 'variant',
          values: [
            'micro',    'small',
            'medium',   'large',
            'eyebrow',  'h1',
            'h2',       'h3',
            'h4',       'h5',
            'h6',       'display1',
            'display2'
          ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        },
        weight: {
          description: 'Sets the font weight, default is regular 400 weight. Does not change accessibility properties.',
          type: 'variant',
          values: [ 'semibold', 'bold' ]
        }
      },
      rules: [
        {
          if: { weight: 'semibold' },
          tokens: { fontName: 'StagSans', fontWeight: '600' }
        },
        {
          if: { weight: 'bold' },
          tokens: { fontName: 'StagSans', fontWeight: '700' }
        },
        {
          description: 'Please only bold single words while using with headings',
          if: { bold: true },
          tokens: { fontName: 'StagSans', fontWeight: '600' }
        },
        {
          if: { size: 'large' },
          tokens: { fontSize: 20, lineHeight: 1.4 }
        },
        {
          if: { size: 'eyebrow' },
          tokens: {
            color: '#000000',
            fontName: 'StagSans',
            fontSize: 14,
            fontWeight: '600',
            lineHeight: 1.42857142857,
            textTransform: 'uppercase'
          }
        },
        {
          if: { size: 'medium' },
          tokens: { fontSize: 16, lineHeight: 1.5 }
        },
        { if: { compact: true }, tokens: { lineHeight: 1.25 } },
        {
          if: { compact: true, size: 'large' },
          tokens: { lineHeight: 1.2 }
        },
        {
          if: { bold: true, compact: true, size: 'large' },
          tokens: { lineHeight: 1.2 }
        },
        {
          if: { size: 'small' },
          tokens: { fontSize: 14, lineHeight: 1.42857142857 }
        },
        {
          if: { compact: true, size: 'small' },
          tokens: { lineHeight: 1.14285714286 }
        },
        {
          if: { size: 'micro' },
          tokens: { fontSize: 12, lineHeight: 1.33333333333 }
        },
        {
          if: { compact: true, size: 'micro' },
          tokens: { lineHeight: 1.2 }
        },
        {
          if: { bold: true, compact: true, size: 'micro' },
          tokens: { lineHeight: 1.2 }
        },
        {
          if: { size: 'display1' },
          tokens: {
            fontName: 'StagSans',
            fontSize: 44,
            fontWeight: '700',
            lineHeight: 1.22222222222
          }
        },
        {
          if: { size: 'display1', viewport: [ 'lg', 'xl' ] },
          tokens: { fontSize: 70, lineHeight: 1.2 }
        },
        {
          if: { size: 'display2' },
          tokens: {
            fontName: 'StagSans',
            fontSize: 36,
            fontWeight: '700',
            lineHeight: 1.22222222222
          }
        },
        {
          if: { size: 'display2', viewport: [ 'lg', 'xl' ] },
          tokens: { fontSize: 54, lineHeight: 1.14285714286 }
        },
        {
          if: { size: 'h1' },
          tokens: {
            fontName: 'StagSans',
            fontSize: 34,
            fontWeight: '700',
            lineHeight: 1.22222222222
          }
        },
        {
          if: { size: 'h1', viewport: [ 'lg', 'xl' ] },
          tokens: { fontSize: 44, lineHeight: 1.22222222222 }
        },
        {
          if: { size: 'h2' },
          tokens: {
            color: '#000000',
            fontName: 'StagSans',
            fontSize: 32,
            fontWeight: '700',
            lineHeight: 1.25
          }
        },
        {
          if: { size: 'h3' },
          tokens: {
            fontName: 'StagSans',
            fontSize: 24,
            fontWeight: '700',
            lineHeight: 1.33333333333
          }
        },
        {
          if: { size: 'h4' },
          tokens: {
            fontName: 'StagSans',
            fontSize: 20,
            fontWeight: '700',
            lineHeight: 1.2
          }
        },
        {
          if: { size: 'h5' },
          tokens: {
            fontName: 'StagSans',
            fontSize: 18,
            fontWeight: '700',
            lineHeight: 1.22222222222
          }
        },
        {
          if: { size: 'h6' },
          tokens: {
            fontName: 'StagSans',
            fontSize: 16,
            fontWeight: '700',
            lineHeight: 1.25
          }
        },
        { if: { inverse: true }, tokens: { color: '#ffffff' } },
        { if: { colour: 'default' }, tokens: { color: '#000000' } },
        { if: { colour: 'brand' }, tokens: { color: '#000000' } },
        { if: { colour: 'dark' }, tokens: { color: '#595959' } },
        { if: { colour: 'light' }, tokens: { color: '#666666' } },
        { if: { colour: 'positive' }, tokens: { color: '#1c7b2b' } },
        { if: { colour: 'warning' }, tokens: { color: '#c9370b' } },
        { if: { colour: 'danger' }, tokens: { color: '#c9370b' } },
        { if: { colour: 'black' }, tokens: { color: '#000000' } },
        { if: { colour: 'white' }, tokens: { color: '#ffffff' } },
        { if: { colour: 'brand2' }, tokens: { color: '#7a3dfc' } },
        { if: { colour: 'brand3' }, tokens: { color: '#5b2bc2' } },
        {
          if: { colour: 'alternative1' },
          tokens: { color: '#404040' }
        },
        {
          if: { colour: 'alternative2' },
          tokens: { color: '#ff0076' }
        },
        {
          if: { colour: 'alternative3' },
          tokens: { color: '#dd0066' }
        }
      ],
      tokens: {
        color: '#000000',
        fontName: 'StagSans',
        fontScaleCap: 64,
        fontSize: 16,
        fontWeight: '400',
        gradient: null,
        letterSpacing: 0,
        lineHeight: 1.5,
        superScriptFontSize: null,
        textTransform: 'none'
      }
    },
    Video: {
      appearances: {},
      rules: [],
      tokens: {
        borderColor: '#000000',
        pauseIcon: PaletteIconPause,
        playIcon: PaletteIconPlaySolid,
        replayIcon: PaletteIconReplay
      }
    },
    VideoButton: { appearances: {}, rules: [], tokens: { color: '#ffffff' } },
    VideoControlBar: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        {
          if: { viewport: [ 'xs', 'sm' ] },
          tokens: {
            height: 40,
            paddingBottom: 16,
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 16
          }
        }
      ],
      tokens: {
        captionsIcon: PaletteIconClosedCaptions,
        height: 56,
        maximizeIcon: PaletteIconFullscreenExpand,
        menuBottom: 64,
        menuMarginLeft: 16,
        menuRight: 32,
        minimizeIcon: PaletteIconFullscreenMinimize,
        paddingBottom: 16,
        paddingLeft: 48,
        paddingRight: 48,
        paddingTop: 16,
        settingsIcon: PaletteIconSettingsSolid
      }
    },
    VideoMenu: {
      appearances: {},
      rules: [],
      tokens: {
        background: '#000000',
        checkMarkFocusColor: '#016b6a',
        checkMarkHeight: 24,
        checkMarkHoverColor: '#016b6a',
        checkMarkIcon: PaletteIconCheck,
        checkMarkSelectedColor: '#000000',
        checkMarkUnselectedColor: 'rgba(0, 0, 0, 0)',
        checkMarkWidth: 24,
        padding: 16
      }
    },
    VideoMiddleControlButton: {
      appearances: {},
      rules: [],
      tokens: {
        background: '#000000',
        height: 64,
        iconColor: '#ffffff',
        width: 64
      }
    },
    VideoPicker: {
      appearances: {},
      rules: [],
      tokens: {
        framedContainerBackgroundColor: '#fafafa',
        framedContainerBorderColor: '#c9c8c8',
        framedContainerBorderRadius: 4,
        framedContainerBorderWidth: 1,
        framedContainerPadding: 24,
        framedMaxHeight: 640,
        stackViewDividerColor: '#c9c8c8'
      }
    },
    VideoPickerSlider: {
      appearances: {},
      rules: [],
      tokens: {
        nextIcon: PaletteIconArrowRight,
        previousIcon: PaletteIconArrowLeft
      }
    },
    VideoPickerThumbnail: {
      appearances: {
        focus: {
          description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        hover: {
          description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
          platforms: [ 'rn', 'web' ],
          type: 'state',
          values: [ true, false ]
        },
        pressed: {
          description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
          type: 'state',
          values: [ true, false ]
        },
        selected: {
          description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
          type: 'state',
          values: [ true ]
        }
      },
      rules: [
        {
          if: { focus: true },
          tokens: {
            borderColor: '#595959',
            borderWidth: 1,
            outerBorderColor: '#000000'
          }
        },
        {
          if: { hover: true },
          tokens: { borderColor: '#c9c8c8', borderWidth: 3 }
        },
        {
          if: { pressed: true },
          tokens: {
            borderColor: '#595959',
            borderWidth: 3,
            outerBorderColor: 'rgba(0, 0, 0, 0)'
          }
        },
        {
          if: { selected: true },
          tokens: { borderColor: '#7a3dfc', titleColor: '#7a3dfc' }
        }
      ],
      tokens: {
        borderColor: '#c9c8c8',
        borderRadius: 4,
        borderWidth: 2,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 2,
        outerBorderRadius: 8,
        outerBorderWidth: 2,
        pressableBorderTopColor: '#c9c8c8',
        pressableBorderTopWidth: 1,
        pressablePaddingBottom: 16,
        pressablePaddingHorizontal: 24,
        pressablePaddingVertical: 16,
        splashButtonRadius: 4,
        subTitleColor: '#595959',
        titleColor: '#000000'
      }
    },
    VideoProgressBar: {
      appearances: {},
      rules: [],
      tokens: {
        rangeBackground: 'rgba(0, 0, 0, 0)',
        remainingTimestampMarginLeft: 8,
        remainingTimestampMarginRight: 0,
        thumbBackground: '#ffffff',
        thumbHeight: 8,
        thumbWidth: 8,
        timestampMarginLeft: 0,
        timestampMarginRight: 8,
        trackGradientEnd: '#7a3dfc',
        trackGradientStart: '#7a3dfc'
      }
    },
    VideoVolumeSlider: {
      appearances: {},
      rules: [],
      tokens: {
        marginLeft: 16,
        marginRight: 16,
        mutedIcon: PaletteIconMuted,
        rangeBackground: 'rgba(0, 0, 0, 0)',
        thumbBackground: '#ffffff',
        thumbHeight: 8,
        thumbWidth: 8,
        trackGradientEnd: '#ffffff',
        trackGradientStart: '#ffffff',
        unmutedIcon: PaletteIconUnmuted
      }
    },
    WaffleGrid: {
      appearances: {
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        { if: { viewport: [ 'xs' ] }, tokens: { rowSize: 2 } },
        { if: { viewport: [ 'sm', 'md' ] }, tokens: { rowSize: 3 } },
        { if: { viewport: [ 'lg', 'xl' ] }, tokens: { rowSize: 6 } }
      ],
      tokens: {
        itemBorderColor: '#c9c8c8',
        itemPadding: 16,
        rowBorderWidth: 1,
        rowSize: 6
      }
    },
    spacingScale: {
      appearances: {
        space: {
          description: 'Index of the intended position on the spacing scale',
          type: 'state',
          values: [
             0, 1, 2, 3,  4,  5,
             6, 7, 8, 9, 10, 11,
            12
          ]
        },
        viewport: {
          description: 'The size label for the current screen viewport based on the current screen width',
          type: 'state',
          values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
        }
      },
      rules: [
        { if: { viewport: [ 'lg', 'xl' ] }, tokens: { size: 120 } },
        { if: { space: 12 }, tokens: { size: 120 } },
        { if: { space: 11 }, tokens: { size: 120 } },
        { if: { space: 10 }, tokens: { size: 80 } },
        { if: { space: 9 }, tokens: { size: 64 } },
        { if: { space: 8 }, tokens: { size: 48 } },
        { if: { space: 7 }, tokens: { size: 40 } },
        { if: { space: 6 }, tokens: { size: 36 } },
        { if: { space: 5 }, tokens: { size: 32 } },
        { if: { space: 4 }, tokens: { size: 24 } },
        { if: { space: 3 }, tokens: { size: 16 } },
        { if: { space: 2 }, tokens: { size: 8 } },
        { if: { space: 1 }, tokens: { size: 4 } },
        {
          if: { space: 11, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 120 }
        },
        {
          if: { space: 10, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 96 }
        },
        {
          if: { space: 9, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 72 }
        },
        {
          if: { space: 8, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 64 }
        },
        {
          if: { space: 7, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 48 }
        },
        {
          if: { space: 6, viewport: [ 'lg', 'xl' ] },
          tokens: { size: 40 }
        },
        { if: { space: 0 }, tokens: { size: 0 } }
      ],
      tokens: { size: 96 }
    }
  },
  metadata: { name: 'theme-koodo', themeTokensVersion: '4.15.1' }
}
export default theme
